<template>
<div>
    <div v-if="isLoading" class="loading">Loading&#8230;</div>
 <!-- @click="modal_close()" -->
<div id="myModalPai" class="modal">
  <div class="modal-background isLink" @click="modal_close()"></div>
  <div class="modal-content" style="width: 70%">
    <div  class="box">

    <PaymentsStudent v-if="student_id"  :studentID="student_id" showHeader="true" :key="student_id" 
        @modal_close="modal_close"
    ></PaymentsStudent> 

    </div>
  </div>
  <button @click="modal_close()" class="modal-close"></button>
</div>
<!-- END MODAL !!!!!!!!!!!!!!!!!!!!!!!!!1  -->


<!-- HEADERS !!!!  -->
<div v-if="header_view=='TAX'" class="columns is-gapless">


<div class="column is-1">
<div class="columns is-multiline is-gapless">
<div v-if="excel_show" class="column is-12"> 
    <download-excel
    class="button is-fullwidth is-dark has-text-light"
    :data="data_excel"
    :fields="excel_fields_show"
    :before-finish   = "impot_export_excel_finish"
    :worksheet="excel_worksheet"
    name="filename.xls"
    > Export it!
    </download-excel>
</div>
<div class="column is-6"> 
    <button @click="impot_export_excel_show_canada()" class="button is-fullwidth has-background-danger has-text-white"><span class="icon is-small"> <i class="fas fa-file-export"></i> </span>&nbsp;&nbsp;CA</button>
</div>

<div class="column is-6"> 
    <button @click="impot_export_excel_show_quebec()" class="button is-fullwidth has-background-info has-text-white"><span class="icon is-small"> <i class="fas fa-file-export"></i> </span>&nbsp;&nbsp;QC</button>
</div>

</div>









</div>

<div class="column is-1 has-text-weight-bold">
        <div class="control">
        <div class="select is-fullwidth">
            <select  v-model="impot_year">
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
            </select>       
        </div>
        </div>
</div> 

<div class="column is-2">
<div class="columns is-gapless">

<div class="column is-9">  
    <div class="control has-icons-left">
    <span class="icon is-left"><i class="fas fa-search"></i></span>
    <input  @keyup.enter="impot_load()" v-model="impot_search" class="input has-text-weight-semibold" placeholder="search ....">
    </div>
</div>
<div class="column is-3">
    <button @click="impot_search_clear()" class="button is-fullwidth has-background-info has-text-white"><span class="icon is-small"> <i class="fas fa-window-close"></i> </span></button>
</div>

</div></div>
<!-- -->


<div class="column is-2">
<!-- NAVIGATION BUTTONS!! -->
<div class="columns has-background-info-light is-gapless is-multiline" >
<div :disabled="page_offset==0" @click="pagination_previous()" class="column is-3"><button class="button is-fullwidth has-text-info"><span class="icon"><i class="fas fa-chevron-left"></i></span> </button></div>
<div class="column is-6 is-size-6 has-text-centered has-text-weight-bold mt-2">{{page_string}}</div>
<div @click="pagination_next()" class="column is-3"><button class="button is-fullwidth has-text-info"><span class="icon"><i class="fas fa-chevron-right"></i></span> </button></div>
</div>
<!-- ** END ** NAVIGATION BUTTONS!! -->
</div>


<div class="column is-1 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Cnt:</span> {{impot_head_cnt}}&nbsp;</div>
<div class="column is-1 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Amt:</span>{{impot_head_amt.toFixed(2)}}&nbsp;</div>

<div class="column is-1 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Sel:</span>{{impot_head_cnt_select}}&nbsp;</div>
<div class="column is-1 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Qc:</span>{{impot_head_amt_qc.toFixed(2)}}&nbsp;</div>
<div class="column is-1 has-text-right has-text-weight is-size-5 colBorderThin"><span class="is-size-7 has-text-link">Can:</span>{{impot_head_amt_can.toFixed(2)}}&nbsp;</div>



    <div @click="switch_header('PAY')" class="column is-1 has-text-right">
        <button @click="switch_view('CALENDAR')" class="button is-fullwidth has-background-info has-text-white"><span class="icon is-small"> <i class="fas fa-calendar-alt"></i> </span>&nbsp;&nbsp;CAL VIEW</button>
    </div>
    
</div>

<div v-if="header_view=='PAY'" class="columns is-centered is-multiline is-gapless" style="margin-bottom:1em;">

  <div v-if="paiment_view=='CALENDAR'" class="column is-1 has-text-weight-bold is-size-6" style=""> 
      <button @click="switch_view('LIST')" class="button is-fullwidth has-background-info has-text-white"><span class="icon is-small"> <i class="fas fa-list"></i> </span>&nbsp;&nbsp;LIST VIEW</button>
  </div>
  <div v-else class="column is-1 has-text-weight-bold is-size-6" style=""> 
      <button @click="switch_view('CALENDAR')" class="button is-fullwidth has-background-info has-text-white"><span class="icon is-small"> <i class="fas fa-calendar-alt"></i> </span>&nbsp;&nbsp;CAL VIEW</button>
  </div>


 <div class="column is-1">
    <p class="control has-icons-left">
        <flat-pickr
            @input="calendar_date_change()"
            v-model="dtStart"
            class="input is-size-6 has-text-weight-bold"
            :config="config"
            placeholder="Calendar Start Date"
            name="dtStart">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div>
 <div class="column is-1">
    <p class="control has-icons-left">
        <flat-pickr
            @input="calendar_date_change()"
            v-model="dtEnd"
            class="input is-size-6 has-text-weight-bold"
            :config="config"
            placeholder="Calendar End Date"
            name="dtEnd">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div>

<div class="column is-5 has-text-weight-bold is-size-5 mt-2"> 
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="is-size-7">Total:&nbsp;&nbsp;</span>{{format_money(pay_total,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="is-size-7">Recu:&nbsp;&nbsp;</span>{{format_money(pay_recu,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="is-size-7">Solde:&nbsp;&nbsp;</span>{{format_money(pay_solde,"$")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>

<!-- SEARCH  -->
<div class="column is-2">
<div class="columns is-gapless">

<div class="column is-8">
    <div class="control has-icons-left">
    <span class="icon is-left"><i class="fas fa-search"></i></span>
    <input @keyup.enter="paiment_search()" v-model="search" class="input has-text-weight-semibold" placeholder="search ....">
    </div>
</div>

  <div class="column is-2 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="paiment_search_clear()" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-times"></i> </span></button>
  </div>

    <!-- CHECK WHAT TO PRINT  v-if="paiment_view=='CALENDAR'" -->
  <div class="column has-text-centered is-2 has-text-right has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button v-print="'#printME'"  class="button has-background-info-light"><span class="icon is-small has-text-grey"> <i class="fas fa-print"></i> </span></button>
  </div>
  <!-- <div v-else class="column has-text-centered is-2 has-text-right has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button v-print="'#printMElist'"  class="button has-background-info-light"><span class="icon is-small has-text-grey"> <i class="fas fa-print"></i> </span></button>
  </div> -->
    <!-- END PRINT -->


</div></div>
<!-- <div @click="paiment_search_clear()" class="column mt-4  is-1 has-text-left isLink has-text-grey-light is-size-7">&nbsp;&nbsp;CLEAR</div> -->




<!-- FILTER BY LATE PAY !! -->
<div v-if="paiment_filter_late" @click="switch_filter('ALL')" class="column is-1 has-text-right"><button class="button is-fullwidth has-text-success has-text-weight-bold"><span class="icon"><i class="fas fa-star"></i></span><span>Show All</span></button> </div>
<div v-else @click="switch_filter('LATE')" class="column is-1 has-text-right"><button class="button  is-fullwidth has-text-danger has-text-weight-bold"><span class="icon"><i class="fas fa-clock"></i></span><span>Late Pay!</span></button> </div>

<div @click="switch_header('TAX')" class="column is-1 has-text-right"><button class="button is-fullwidth has-background-light has-text-danger has-text-weight-bold"><span class="icon"><i class="fas fa-file-invoice"></i></span><span>IMPOT</span></button> </div>

</div>
<!-- END HEADER PAI !!!! -->
  







<div id="printME">
 <!-- BEGIN CALENDAR DATA !!!!  -->
<div v-if="paiment_view=='CALENDAR'" class="columns is-centered is-multiline is-gapless">
<div class="column is-11">

<div class="columns is-multiline is-gapless has-background-grey-light">
<div :class="return_column_size(data)" class="mb-4" v-for ="(data, index) in sched_days" :key="index">

<div class="columns is-gapless colBorder" :class="return_style_month_change(data)" style="margin-bottom:0em;">
    <div class="column is-4 is-size-7 has-text-left has-text-dark has-text-weight-bold">
        &nbsp;&nbsp;{{moment(data).format('ddd')}}
    </div>
    <div class="column is-8 has-text-right has-text-dark has-text-weight-bold">
        {{moment(data).format('MMMDD')}}&nbsp;&nbsp;
    </div>
</div>

<!-- <span class=""> &nbsp;&nbsp; {{moment(data).format('ddd MMM DD')}} &nbsp;&nbsp; </span> -->

    <div @click="payment_click(s_data.student_ID)" class="columns isLink is-multiline is-gapless" style="margin-bottom:0em;" v-for ="(s_data, index) in calendar_load_day(data)" :key="index">
     
        <div class="column is-8 has-background-white colBorderThin"> 
        <div class="columns is-multiline is-gapless">
            <div class="column is-2">          
            <figure class="image is-32x32">
            <img class="is-rounded" :src="return_pic()">
            </figure>       
            </div>


            <div class="column is-10">   
                <div class="columns is-multiline is-gapless">      
                    <div class="column is-12 has-text-weight-bold is-uppercase">{{s_data.student_lNAME}}</div>
                    <div class="column is-8 is-size-7 is-uppercase" style="margin-top:-.5em;"> {{s_data.student_fNAME}}</div>
                    <div class="column is-4 is-size-7 has-text-weight-bold has-text-grey has-text-centered" style="margin-top:-.5em;"> {{s_data.payment_Number}}</div>
                </div>
            </div>
        </div>
        </div>

       <div class="column is-4 is-size-7 mt-3 has-text-right has-text-weight-bold" :style="return_style_calendar_item(s_data.payment_Rec,s_data.payment_DueDate)">{{format_money(s_data.payment_Amount,'$')}} &nbsp;</div>
    </div>


</div>


</div>
</div> <!-- END COL MAIN  -->
</div>
<!-- ************************************ END CALENDAR ******************************************  -->


 <!-- BEGIN LIST DATA !!!!  -->
<div v-if="paiment_view=='LIST'" class="columns is-centered is-multiline is-gapless mt-6">
<div class="column is-9">

<div class="columns is-gapless is-size-7 has-text-weight-bold" style="margin-bottom:0em;">
    <div class="column is-2">STUDENT</div>
    <div class="column is-2 has-text-right">DATE DUE</div>
    <div class="column is-1 has-text-right">AMOUNT</div>
    <div class="column is-1"></div>
    <div class="column is-1 has-text-right">OWE</div>
    <div class="column is-1 has-text-right">PAY</div>
    <div class="column is-1 has-text-right">SOLDE</div>
</div>



<div @click="payment_click(data.student_ID)" style="margin-bottom:0em;padding-top:.5em;padding-bottom:.5em;" class="columns colBorderThin isLink is-gapless" v-for ="(data, index) in sched_data" :key="index">
    <div class="column is-2">&nbsp;{{data.student_lNAME}}, {{data.student_fNAME}}</div>
    <div class="column is-2 has-text-right">{{ data.payment_DueDate | moment("add", "1 days","ddd MMM-D-YY")}}&nbsp;&nbsp;&nbsp;&nbsp;</div>
    <div class="column is-1 has-text-right" :style="return_style_calendar_item(data.payment_Rec,data.payment_DueDate)">{{format_money(data.payment_Amount,'$')}} &nbsp;</div>

    <div class="column is-1"></div>

    <div class="column is-1 has-text-right">{{format_money(data.student_frais_owe,'$')}} &nbsp;</div>
    <div class="column is-1 has-text-right">{{format_money(data.student_frais_pay,'$')}} &nbsp;</div>
    <div class="column is-1 has-text-right">{{format_money(data.student_frais_solde,'$')}} &nbsp;</div>



</div>
<!-- END LOOP  -->
</div> <!-- END COL MAIN  -->
</div>
<!-- ************************************ END LIST ******************************************  -->


 <!-- BEGIN IMPOT DATA !!!!  -->
<div v-if="paiment_view=='IMPOT'" >

<div class="columns is-centered is-multiline is-gapless" style="margin-bottom:0em;">
    <div @click="impot_order_by('student_lNAME')" class="column mt-6 is-1 isLink hasTextLink has-text-link is-size-7 has-text-weight-bold"> 
        Nom&nbsp;<span class="icon mt-2 has-text-link is-small"><i class="fas fa-sort"></i></span> 
    </div>

    <div class="column is-1 isLink has-text-link is-size-7 has-text-weight-bold">  
    <div class="columns is-gapless">
        <div @click="impot_order_by('student_CreateDate')" class="column mt-6 is-6 has-text-centered">DT S&nbsp;<span class="icon mt-2 has-text-link is-small"><i class="fas fa-sort"></i></span> </div>
        <div @click="impot_order_by('student_EndDate')" class="column mt-6 is-6 has-text-centered">DT E&nbsp;<span class="icon mt-2 has-text-link is-small"><i class="fas fa-sort"></i></span> </div>
    </div></div>
    <!-- END DATE SORE COL  -->

    <div @click="impot_order_by('student_GRPCODE')" class="column mt-6 is-1 isLink has-text-link is-size-7 has-text-weight-bold has-text-right">Grp Code&nbsp;<span class="icon mt-2 has-text-link is-small"><i class="fas fa-sort"></i></span>  &nbsp;&nbsp;&nbsp;&nbsp; </div>
    <!-- <div class="column is-1 isLink has-text-link is-size-7 has-text-weight-bold"> </div> -->
    <div @click="impot_order_by('amt')" class="column mt-6 is-1 isLink hasTextLink has-text-link is-size-7 has-text-weight-bold has-text-right"> Amount&nbsp;<span class="icon mt-2 has-text-link is-small"><i class="fas fa-sort"></i></span> </div>



    <!-- <div class="column is-1"></div> -->

    <div class="column  mt-6 is-2 has-text-weight-bold colNotes has-text-right">AMOUNT QUEBEC 2020</div>


<div class="column is-4">
<div class="columns is-gapless is-centered is-multiline">

    <div class="column is-3">
        <div class="columns mt-4 is-multiline is-gapless is-size-7 has-text-centered">
            <div class="column is-12 has-text-weight-bold colBorderThin has-background-grey-light">CAN 1</div>
            <div class="column is-4 colBorderThin has-text-grey-light">HRS</div>
            <div class="column is-4 colBorderThin has-text-grey-light">PT</div>
            <div class="column is-4 colBorderThin has-text-grey-light">FT</div>
            <div class="column is-6 colBorderThin has-text-grey-light">START</div>
            <div class="column is-6 colBorderThin has-text-grey-light">END</div>
            <div class="column is-12 colBorderThin has-text-grey-light">AMOUNT</div>
    </div></div>

    <div class="column is-3 has-text-weight-bold">        
        <div class="columns mt-4 is-multiline is-gapless is-size-7 has-text-centered">
            <div class="column is-12 has-text-weight-bold colBorderThin has-background-grey-light">CAN 2</div>
            <div class="column is-4 colBorderThin has-text-grey-light">HRS</div>
            <div class="column is-4 colBorderThin has-text-grey-light">PT</div>
            <div class="column is-4 colBorderThin has-text-grey-light">FT</div>
            <div class="column is-6 colBorderThin has-text-grey-light">START</div>
            <div class="column is-6 colBorderThin has-text-grey-light">END</div>
            <div class="column is-12 colBorderThin has-text-grey-light">AMOUNT</div>
    </div></div>
    <div class="column is-3 has-text-weight-bold">
            <div class="columns mt-4 is-multiline is-gapless is-size-7 has-text-centered">
            <div class="column is-12 has-text-weight-bold colBorderThin has-background-grey-light">CAN 3</div>
            <div class="column is-4 colBorderThin has-text-grey-light">HRS</div>
            <div class="column is-4 colBorderThin has-text-grey-light">PT</div>
            <div class="column is-4 colBorderThin has-text-grey-light">FT</div>
            <div class="column is-6 colBorderThin has-text-grey-light">START</div>
            <div class="column is-6 colBorderThin has-text-grey-light">END</div>
            <div class="column is-12 colBorderThin has-text-grey-light">AMOUNT</div>
    </div>
    </div>
</div></div>


    <!-- <div class="column is-1 has-text-weight-bold"></div> -->
    <!-- <div class="column is-1 has-text-weight-bold"></div> -->

</div>


<div class="columns is-centered is-multiline is-gapless " v-for ="(data, index) in impot_data_studs" :key="index" style="margin-bottom:0em;">

<div class="column is-12" style="border-bottom: 5px dashed lightgray;">
<StudentTaxes
:data="data" :data_tax="impot_filter_stud_tax(data.student_ID)" :impot_year="impot_year" :key="data.student_ID"
@emit_impot_change="emit_impot_change"
@emit_impot_show_payments="emit_impot_show_payments"
> </StudentTaxes>
</div>


</div></div>
<!-- ************************************ END IMPOT ******************************************  -->





</div> <!-- !!!! END PRINT !!!!  -->



</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import myUtilities from "@/assets/js/utilities.js";

import PaymentsStudent  from '@/components/Comp_Student_Pay_II';

import StudentTaxes  from '@/components/Comp_Student_Taxes';

import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import startOfWeek from 'date-fns/startOfWeek'
import addMonths from 'date-fns/addMonths'
import subMonths from 'date-fns/subMonths'
import isWeekend from 'date-fns/isWeekend'
import getMonth from 'date-fns/getMonth'

// import JsonExcel from "vue-json-excel";

export default {
        props: [ ],
        components: { PaymentsStudent , StudentTaxes },

        data() {
            return {

excel_show:false,
data_excel:[],
excel_worksheet:'',
excel_fields_show:[], // WHICH HEADERS


excel_fields_QC: {
    'b1': 'colA',
    'b2': 'colB',
    'b3': 'colC',
    'lastname': 'colD',
    'firstname': 'colE',
    'b4': 'colF',
    'address': 'colG',
    'b5': 'colH',
    'city': 'colI',
    'prov': 'colJ',
    'postal': 'colK',
    'country': 'colL',
    'year': 'colM',
    'amount': 'colN',
    'tuition': 'colO',
    'dons': 'colP',
    'sin': 'colQ',
    'codeperm': 'colR',
    'numadmin': 'colS',
    'code': 'colT',
    'email': 'colU',
    'emailok': 'colV'
},


excel_fields_CAN: {
    'b1': 'colA',
    'b2': 'colB',
    'b3': 'colC',
    'lastname': 'colD',
    'firstname': 'colE',
    'b4': 'colF',
    'address': 'colG',
    'b5': 'colH',
    'city': 'colI',
    'prov': 'colJ',
    'postal': 'colK',
    'country': 'colL',
    'year': 'colM',
    'sin': 'colN',
    'status': 'colO',
    'program': 'colP',
    'number': 'colQ',
    'b6': 'colR',

'fy1': 'colS',
'fm1': 'colT',
'ty1': 'colU',
'tm1': 'colV',
'fees1': 'colW',
'pt1': 'colX',
'ft1': 'colY',

'fy2': 'colZ',
'fm2': 'colAA',
'ty2': 'colAB',
'tm2': 'colAC',
'fees2': 'colAD',
'pt2': 'colAE',
'ft2': 'colAF',

'fy3': 'colAG',
'fm3': 'colAH',
'ty3': 'colAI',
'tm3': 'colAJ',
'fees3': 'colAK',
'pt3': 'colAL',
'ft3': 'colAM',

'b7': 'colAN',
'b8': 'colAO',
'b9': 'colAP',
'b10': 'colAQ',
'b11': 'colAR',
'b12': 'colAS',
'b13': 'colAT',

'b14': 'colAU',
'email': 'colAV',
'emailok': 'colAW',

},








paiment_view:"CALENDAR",
paiment_filter_late:false,
data_paiments:[], // HOLDS LIST WHIE FILTERING
paiment_filter : 'ALL',

header_view : 'PAY',

isLoading:false,
search:'',
today : moment().format('YYYY-MM-DD'),  //this.get_date(),
dtStart:'',
dtEnd:'',
sched_data:[],
sched_days:[],
temp_data:[],

data_student:[],
student_id:'',

pay_total:0,
pay_recu:0,
pay_solde:0,


// ---- PAGING ----
page_offset: 0,
page_count: 50,
page_max: 0,
page_string:'',

impot_search: '',
impot_year:2021,
impot_data_studs_temp:[], // HOLD SO NO LOAD
impot_data_studs:[],
impot_data_tax:[],
impot_sql:'',

impot_head_cnt:0,
impot_head_amt:0,
impot_head_cnt_select:0,
impot_head_amt_qc:0,
impot_head_amt_can:0,


impot_order_desc:'student_lNAME',
impot_order_order:'ASC',

config: { // FLATPICKER
    altFormat: "M j y",
    altInput: true
},

query_temp:'',

                 
            }
        },

mounted(){
    

// CHECK IF HAS DATES ALREADY ....
    if (sessionStorage.getItem('pay_date_start')) {
        this.dtStart =  sessionStorage.getItem('pay_date_start')
        this.dtEnd =  sessionStorage.getItem('pay_date_end')
    } else {
        this.dtStart = moment().subtract(7, "days").weekday(0).format('YYYY-MM-DD');
        this.dtEnd = moment(this.dtStart).add(14, "days").format('YYYY-MM-DD')

    }

    this.get_paiement_info()

}, // END CREATED


// var query = `SELECT DISTINCT 
// MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, COUNT(MyMEQ_COURSESTUDENT.cs_ID) AS cnt, 
// MyMEQ_STUDENT.student_frais_owe, MyMEQ_STUDENT.student_frais_pay, MyMEQ_STUDENT.student_frais_solde
// FROM MyMEQ_STUDENT INNER JOIN
// MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN
// MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID
// WHERE (MyMEQ_GROUP.group_ANN = '20')
// GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_frais_owe, MyMEQ_STUDENT.student_frais_pay, 
// MyMEQ_STUDENT.student_frais_solde, MyMEQ_STUDENT.student_fNAME`


    methods : {




impot_export_excel_finish:function() {
        this.excel_show=false; 
},

impot_export_excel_show_canada:function() {

// CONSTRUCT DATA CANADA
    var query = ` SELECT '' AS colA, '' AS colB, '' AS colC, MyMEQ_STUDENT.student_lNAME AS colD, MyMEQ_STUDENT.student_fNAME AS colE, '' AS colF, 
                         MyMEQ_STUDENT.student_apt + ' ' + MyMEQ_STUDENT.student_rueNUM + ' ' + MyMEQ_STUDENT.student_Address AS colG, '' AS colH, 
                         MyMEQ_STUDENT.student_City AS colI, MyMEQ_STUDENT.student_Province AS colJ, MyMEQ_STUDENT.student_Postal AS colK, 'CA' AS colL, '2020' AS colM
        , student_SIN as colN, 'O' as colO, prog_TITRE_F As colP, student_codeperm as colQ, '' as colR,''	as 'colS',''  as 'colT',''  as 'colU',''  as 'colV','' as  'colW',''  as 'colX',''  as 'colY',''	as 'colZ',''  as 'colAA',''  as 'colAB',''  as 'colAC','' as  'colAD',''  as 'colAE',''  as 'colAF',''	as 'colAG',''  as 'colAH',''  as 'colAI',''  as 'colAJ','' as  'colAK',''  as 'colAL',''  as 'colAM',''	as 'colAN',''  as 'colAO',''  as 'colAP',''  as 'colAQ','' as  'colAR',''  as 'colAS',''  as 'colAT',''  as  'colAU',student_eMail as 'colAV','Yes' as  'colAW'
   , myMEQ_STUDENT_TAX.* FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TAX ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TAX.student_ID left outer join MyMEQ_PROGRAM ON myMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
            var data_temp = res.data

// SORT OUT SEMESTERS

        for (var i = 0; i < data_temp.length; i++) {
// CAN 1
            if (data_temp[i].studTax_CAN_1 != '|||||') { var spl = data_temp[i].studTax_CAN_1.split("|") 
                    data_temp[i].colS = '2020' 
                    data_temp[i].colT = spl[2]
                    data_temp[i].colU = '2020'
                    data_temp[i].colV = spl[3]
                    data_temp[i].colW = spl[4]
                    data_temp[i].colX = spl[0]
                    data_temp[i].colY = spl[1]
            }
// CAN 2
            if (data_temp[i].studTax_CAN_2 != '|||||') { var spl = data_temp[i].studTax_CAN_2.split("|") 
                    data_temp[i].colZ = '2020' 
                    data_temp[i].colAA = spl[2]
                    data_temp[i].colAB = '2020'
                    data_temp[i].colAC = spl[3]
                    data_temp[i].colAD = spl[4]
                    data_temp[i].colAE = spl[0]
                    data_temp[i].colAF = spl[1]
            }
// CAN 3
            if (data_temp[i].studTax_CAN_3 != '|||||') { var spl = data_temp[i].studTax_CAN_3.split("|") 
                    data_temp[i].colAG = '2020' 
                    data_temp[i].colAH = spl[2]
                    data_temp[i].colAI = '2020'
                    data_temp[i].colAJ = spl[3]
                    data_temp[i].colAK = spl[4]
                    data_temp[i].colAL = spl[0]
                    data_temp[i].colAM = spl[1]
            }




        } // END FOR


        this.excel_fields_show = this.excel_fields_CAN
        this.data_excel = data_temp
        this.excel_worksheet = 'data canada'
        this.excel_show=true;
    });
},
impot_export_excel_show_quebec:function() {

// CONSTRUCT DATA quEBEC
    var query = `SELECT        '' AS colA, '' AS colB, '' AS colC, MyMEQ_STUDENT.student_lNAME AS colD, MyMEQ_STUDENT.student_fNAME AS colE, '' AS colF, 
                         MyMEQ_STUDENT.student_apt %2B ' ' %2B MyMEQ_STUDENT.student_rueNUM %2B ' ' %2B MyMEQ_STUDENT.student_Address AS colG, '' AS colH, 
                         MyMEQ_STUDENT.student_City AS colI, MyMEQ_STUDENT.student_Province AS colJ, MyMEQ_STUDENT.student_Postal AS colK, 'CA' AS colL, '2020' AS colM, 
                         myMEQ_STUDENT_TAX.studTax_QC_AMT AS colN, ROUND(studTax_CAN_AMT,2) AS colO, 0 AS colP,MyMEQ_STUDENT.student_SIN AS colQ, MyMEQ_STUDENT.student_CodePerm AS colR, MyMEQ_STUDENT.student_NumAdmission AS colS, 'R' AS colT, 
                         MyMEQ_STUDENT.student_eMail as colU, 'Yes' as colV

FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TAX ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TAX.student_ID`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.excel_fields_show = this.excel_fields_QC
        this.data_excel = res.data
        this.excel_worksheet = 'data quebec'
        this.excel_show=true;
    });
},

check_pagination:function(cnt) {
    if (cnt>this.page_count){

        this.page_offset = 0
        this.page_max = cnt

        this.page_string = '1-' + this.page_count + ' of ' + this.page_max
    } else {
        this.page_string = '1-' + cnt + ' of ' + cnt
        this.page_offset = 0
        this.page_max = cnt
    } // END IF
}, // END PAGINATION CHECK

pagination_next:function() {
    // CHECK IF OVER
    if ((Number(this.page_offset)+Number(this.page_count)) > this.page_max) {return}
    this.page_offset = Number(this.page_offset) + Number(this.page_count)
// CHECK IF LAST
if ((Number(this.page_offset)+Number(this.page_count)) > this.page_max) 
{this.page_string = (Number(this.page_offset) + 1) + '-' + this.page_max  + ' of ' + this.page_max}
else
{this.page_string = (Number(this.page_offset) + 1) + '-' + (Number(this.page_offset)+Number(this.page_count))  + ' of ' + this.page_max}

this.impot_load()

},

pagination_previous:function() {
    if (this.page_offset == 0) {return}
    this.page_offset = Number(this.page_offset) - Number(this.page_count)

    this.page_string = (Number(this.page_offset)+1) + '-' + (Number(this.page_offset)+Number(this.page_count))  + ' of ' + this.page_max
    
    this.impot_load()
},

emit_impot_show_payments:function(id) {
    this.student_id = id
    document.querySelector('#myModalPai').classList.add('is-active');
},

emit_impot_change:function(doWhat , amtQC, amtCAN) {
    
    if (doWhat == 'ADD') {
        this.impot_head_cnt_select++
        this.impot_head_amt_qc = parseFloat(this.impot_head_amt_qc) + parseFloat(amtQC)
        this.impot_head_amt_can = parseFloat(this.impot_head_amt_can) + parseFloat(amtCAN)
    } else {
        this.impot_head_cnt_select--
        this.impot_head_amt_qc = parseFloat(this.impot_head_amt_qc) - parseFloat(amtQC)
        this.impot_head_amt_can = parseFloat(this.impot_head_amt_can) - parseFloat(amtCAN)        
    }
},



impot_filter_stud_tax:function(stud_id) {
// FILTER BEFORE SENDING TO COMP.
    const aTax = this.impot_data_tax.filter((s) => s.student_ID === stud_id)
    return aTax
},

impot_order_by:function(orderBy) {
// CHECK IF CHANGING ASC/DESC
    if (this.impot_order_desc == orderBy) 
        { if (this.impot_order_order == 'DESC') {this.impot_order_order='ASC'} else {this.impot_order_order='DESC'}  
    } else {
        this.impot_order_desc = orderBy
    }
    this.impot_load()
},
impot_tax_start:function() {

    this.isLoading=true;
    this.impot_sql = ''
    this.doSynchronousLoop(this.impot_data_studs_temp,this.impot_tax_do, this.impot_tax_done)
},

impot_tax_do:function(item, i, callback) {
    

    this.impot_sql += " ((MyMEQ_COURSESTUDENT.student_ID = " + item.student_ID + ") AND (MyMEQ_GROUP.group_ANN = '21')) OR "
    callback()

},
impot_tax_done:function() {
   
this.impot_sql = this.impot_sql.substring(0, this.impot_sql.length-3)
var query = `SELECT MyMEQ_COURSESTUDENT.student_ID, MyMEQ_GROUP.group_SESS, SUM(MyMEQ_COUR.cour_HOURS) AS hrs FROM MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE ` + this.impot_sql + ` GROUP BY MyMEQ_COURSESTUDENT.student_ID, MyMEQ_GROUP.group_SESS`

console.log('----')
console.log(query)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    var data_temp = res.data
     
// CHECK IF NOTHING
if (data_temp.length==0) {return}


for (var x=0; x < this.impot_data_studs_temp.length; x++) {  
    
        const aHrs = data_temp.filter((s) => s.student_ID === this.impot_data_studs_temp[x].student_ID)
        var hrsTotal = 0

        for (var i = 0; i < aHrs.length; i++) {
            hrsTotal = Number(hrsTotal) + Number(aHrs[i].hrs)

if (aHrs[i].group_SESS == 'H') {this.impot_data_studs_temp[x].hrs_can_1 = aHrs[i].hrs}
if (aHrs[i].group_SESS == 'E') {this.impot_data_studs_temp[x].hrs_can_2 = aHrs[i].hrs}
if (aHrs[i].group_SESS == 'A') {this.impot_data_studs_temp[x].hrs_can_3 = aHrs[i].hrs}

        }

    this.impot_data_studs_temp[x].hrs_total = hrsTotal

}

    this.isLoading=false;
    this.impot_data_studs = this.impot_data_studs_temp // LOAD THE DATA !!!!
});


},


doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
},


impot_search_clear:function() {
    this.impot_search = ''
    this.impot_load()
},

impot_load:function(doHeader) {
this.isLoading=true;

var sWhere = ''
if (this.impot_search != '') {
    sWhere = " AND ((student_GRPCODE LIKE '" + this.impot_search + "%25') " 
    sWhere += " OR (student_lNAME LIKE '" + this.impot_search + "%25') " 
    sWhere += " OR (student_CodePerm LIKE '" + this.impot_search + "%25')) "
}


var orderIt = ' ORDER BY ' + this.impot_order_desc + ' ' + this.impot_order_order
var query = `SELECT  DISTINCT 
MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_frais_owe, 
MyMEQ_STUDENT.student_frais_pay, MyMEQ_STUDENT.student_frais_solde, SUM(MyMEQ_STUDENT_PAYMENT.payment_Amount) AS amt, 
MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_CreateDate, MyMEQ_STUDENT.student_EndDate, MyMEQ_STUDENT.student_blnComplete
,student_SIN, student_CodePerm, student_NumAdmission, 0 AS hrs_total, 0 AS hrs_can_1, 0 AS hrs_can_2, 0 AS hrs_can_3, 0 AS hrs_can_4   FROM            MyMEQ_STUDENT INNER JOIN
MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
WHERE        (MyMEQ_STUDENT_PAYMENT.payment_RecDate BETWEEN '` + this.impot_year + `-01-01' AND '` + this.impot_year + `-12-31')
` + sWhere + `
GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_frais_owe, MyMEQ_STUDENT.student_frais_pay, MyMEQ_STUDENT.student_frais_solde, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_CreateDate, 
MyMEQ_STUDENT.student_EndDate, MyMEQ_STUDENT.student_blnComplete,student_SIN, student_CodePerm, student_NumAdmission ` + orderIt
 query +=   ` OFFSET ` + this.page_offset + ` ROWS FETCH NEXT ` + this.page_count + ` ROWS ONLY`

console.log(query)


axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.impot_data_studs_temp = res.data // PUT IN TEMP SO DOESN'T LOAD YET !

// GET THE TaX INFO
var query = `SELECT * FROM myMEQ_STUDENT_TAX WHERE studTax_YEAR = 2020`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.impot_data_tax = res.data
    
    var query = `SELECT COUNT(DISTINCT MyMEQ_STUDENT.student_ID) AS cnt, SUM(payment_Amount) AS amt FROM MyMEQ_STUDENT INNER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
    WHERE (payment_RecDate BETWEEN '` + this.impot_year + `-01-01' AND '` + this.impot_year + `-12-31') ` + sWhere  

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
    this.impot_head_cnt = res.data[0].cnt
    this.impot_head_amt = res.data[0].amt

// CHECK IF NEeD TO SET PAGE ....
 if (doHeader || sWhere != '') {
    this.check_pagination(res.data[0].cnt)
 }

var query = `SELECT COUNT(DISTINCT MyMEQ_STUDENT.student_ID) AS cnt, SUM(studTax_QC_AMT) AS amt_qc, SUM(studTax_CAN_AMT) AS amt_can FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TAX ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TAX.student_ID ` 
if (sWhere != '') {query += sWhere}


    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.impot_head_cnt_select = res.data[0].cnt
        if (this.impot_head_cnt_select > 0) {
            this.impot_head_amt_qc = res.data[0].amt_qc
            this.impot_head_amt_can = res.data[0].amt_can
        } else {
            this.impot_head_amt_qc = 0
            this.impot_head_amt_can = 0            
        }

    this.isLoading=false;
    this.impot_tax_start()
});  });

});  });

},



switch_header:function(view) {
    this.header_view = view
    if (view == 'TAX') {this.paiment_view = 'IMPOT'
    this.impot_load(true) }
    else {this.paiment_view = 'CALENDAR'}

},
switch_view:function(view) {
    this.paiment_view = view
},
switch_filter:function(view) {
    this.sched_data = []
    this.paiment_filter = view

    if (view == 'ALL')
    { this.sched_data = this.data_paiments ; this.paiment_filter_late = false }
    else {
       this.paiment_filter_late = true
       for (var i = 0; i < this.data_paiments.length; i++) {
           if (this.data_paiments[i].payment_Rec != "1" && moment(this.data_paiments[i].payment_DueDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD'))
           { this.sched_data.push(this.data_paiments[i])}
       } // END FOR
    } // END IF
    
},






paiment_search_clear:function() {

this.isLoading=true;
    this.search = ''
    // this.dtStart = moment().subtract(21, "days").weekday(0).format('YYYY-MM-DD');
    // this.dtEnd = moment(this.dtStart).add(84, "days").format('YYYY-MM-DD')
this.isLoading=false;  
this.get_paiement_info()

},

paiment_search:function() {
if (this.search=='') {this.paiment_search_clear() ; return}
this.isLoading=true;

    var sWhere = " ((student_GRPCODE LIKE '" + this.search + "%25') " 
    sWhere += " OR (student_lNAME LIKE '" + this.search + "%25') " 
    sWhere += " OR (student_CodePerm LIKE '" + this.search + "%25')) "

    var query = `SELECT SUM(payment_Amount) AS amt, payment_Rec FROM MyMEQ_STUDENT INNER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
    WHERE (payment_Amount > 0) AND ` + sWhere + `
    AND (payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `')
    GROUP BY payment_Rec ORDER BY payment_Rec`

this.sched_data=[]
this.pay_solde=0
this.pay_recu=0
this.pay_total=0

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        // THIS CHECKS FOR RESULTS
        if (!res.data[0]) { this.isLoading=false; return }

        if (res.data.length==2) {
            this.pay_solde = res.data[0].amt
            this.pay_recu = res.data[1].amt
        } else {
            if (res.data[0].payment_Rec == "1") {this.pay_recu = res.data[0].amt}
            else {this.pay_solde = res.data[0].amt}
        }
        this.pay_total = Number(this.pay_solde) + Number(this.pay_recu)


// GET START/END DATE
    // var query = `SELECT MIN(MyMEQ_STUDENT_PAYMENT.payment_DueDate) AS dtMIN, MAX(MyMEQ_STUDENT_PAYMENT.payment_DueDate) AS dtMAX FROM MyMEQ_STUDENT INNER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID
    // WHERE (payment_Amount > 0) AND ` + sWhere 
    // axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    // .then(res => {


    //     this.dtStart = moment(res.data[0].dtMIN).weekday(0).format('YYYY-MM-DD');
    //     this.dtEnd = moment(res.data[0].dtMAX).add(7,"days").format('YYYY-MM-DD')

var query = `SELECT MyMEQ_STUDENT_PAYMENT.payment_ID, MyMEQ_STUDENT_PAYMENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, 
 MyMEQ_STUDENT_PAYMENT.payment_Number, MyMEQ_STUDENT_PAYMENT.payment_Amount, MyMEQ_STUDENT_PAYMENT.payment_DueDate, 
 MyMEQ_STUDENT_PAYMENT.payment_Rec, MyMEQ_STUDENT_PAYMENT.payment_RecDate, MyMEQ_STUDENT_PAYMENT.payment_Type , student_frais_owe,student_frais_pay,student_frais_solde
FROM  MyMEQ_STUDENT_PAYMENT INNER JOIN MyMEQ_STUDENT ON MyMEQ_STUDENT_PAYMENT.student_ID = MyMEQ_STUDENT.student_ID 
WHERE (payment_Amount > 0) AND ` + sWhere  + ` 
AND (payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `')
ORDER BY MyMEQ_STUDENT_PAYMENT.payment_DueDate,payment_Number`
console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.data_paiments = res.data

        this.switch_filter(this.paiment_filter)
        // this.sched_data = res.data


        this.calendar_load()


        this.isLoading=false;
    });    });   // });


},


get_paiement_info:function() {
// GET ALL PAIMENTS AND TOTALS FOR DATE RANGE 

    sessionStorage.setItem('pay_date_start', this.dtStart)
    sessionStorage.setItem('pay_date_end', this.dtEnd)


this.isLoading=true;
var query = `SELECT SUM(payment_Amount) AS amt, payment_Rec FROM MyMEQ_STUDENT_PAYMENT
WHERE (payment_Amount > 0) AND (payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `')
GROUP BY payment_Rec ORDER BY payment_Rec`
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
        if (!res.data[0]) { this.isLoading=false; return }

        if (res.data.length==2) {
            this.pay_solde = res.data[0].amt
            this.pay_recu = res.data[1].amt
        } else {
            if (res.data[0].payment_Rec == "1") {this.pay_recu = res.data[0].amt}
            else {this.pay_solde = res.data[0].amt}
        }
        this.pay_total = Number(this.pay_solde) + Number(this.pay_recu)


var query = `SELECT MyMEQ_STUDENT_PAYMENT.payment_ID, MyMEQ_STUDENT_PAYMENT.student_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, 
 MyMEQ_STUDENT_PAYMENT.payment_Number, MyMEQ_STUDENT_PAYMENT.payment_Amount, MyMEQ_STUDENT_PAYMENT.payment_DueDate, 
 MyMEQ_STUDENT_PAYMENT.payment_Rec, MyMEQ_STUDENT_PAYMENT.payment_RecDate, MyMEQ_STUDENT_PAYMENT.payment_Type  , student_frais_owe,student_frais_pay,student_frais_solde
FROM  MyMEQ_STUDENT_PAYMENT INNER JOIN MyMEQ_STUDENT ON MyMEQ_STUDENT_PAYMENT.student_ID = MyMEQ_STUDENT.student_ID 
WHERE (payment_Amount > 0) AND (MyMEQ_STUDENT_PAYMENT.payment_DueDate BETWEEN '` + this.dtStart + `' AND '` + this.dtEnd + `') 
ORDER BY MyMEQ_STUDENT_PAYMENT.payment_DueDate,payment_Number`
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
     this.data_paiments = res.data

    this.switch_filter(this.paiment_filter)
    // this.sched_data = res.data

    this.calendar_load()
    this.isLoading=false;
});  });  // END AXIOS

},










modal_close:function(doUpdate) {
    document.querySelector('#myModalPai').classList.remove('is-active');
    this.student_id = null
    if (doUpdate==true) {this.get_paiement_info()} // RELOAD DATA
  },
calendar_date_change:function() {
    if (this.isLoading==true) {return}
    this.get_paiement_info()
},


payment_click:function(id) {


this.student_id = id
document.querySelector('#myModalPai').classList.add('is-active');

    // this.isLoading=true;
    // var query = `SELECT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_eMail, MyMEQ_STUDENT.student_TelHome, MyMEQ_STUDENT.student_TelOther, MyMEQ_STUDENT_PAYMENT.payment_Number, MyMEQ_STUDENT_PAYMENT.payment_Amount, MyMEQ_STUDENT_PAYMENT.payment_DueDate, MyMEQ_STUDENT_PAYMENT.payment_Rec FROM MyMEQ_STUDENT INNER JOIN
    // MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID WHERE MyMEQ_STUDENT.student_ID = ` + id + ` ORDER BY payment_DueDate`
    // axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    // .then(res => { 
    //     this.data_student = res.data
    //     document.querySelector('#myModalPai').classList.add('is-active');
    //     this.isLoading=false;
    // }); // END AXIOS

}, // END PAY CLICK


 


return_column_size:function(dtIN) {
// IF WEEKEND COL = 1

var retStyle = 'column colBorder'

    if (isWeekend(new Date(dtIN))) {retStyle += " is-1 "} else {retStyle += " is-2 "} // ENDIF
// hLight monthchange
    var mo = getMonth(new Date(dtIN))
    if (mo % 2 === 0)  {
        retStyle += " has-background-light "
    } else {
        retStyle += " has-background-light "
    } // ENDIF

return retStyle

}, // END COLUMN SIZE

return_style_month_change:function(dtIN) {
// hLight monthchange
    var mo = getMonth(new Date(dtIN))
    if (mo % 2 === 0)  {
        return " has-background-link-light "
    } else {
        return " has-background-warning-light "
    } // ENDIF
},



return_style_calendar_item:function(rec, dtIn) {

    var retStyle = 'margin-bottom:0em;' 
    if (rec) { retStyle += 'background-color: ' + 'rgba(0, 255, 0, 0.2)' + ';' }
    else if (moment(dtIn).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') ) { retStyle += 'background-color: ' + 'rgba(255, 0, 0, 0.3)' + ';' }
    else {retStyle += 'background-color: ' + 'white' + ';'} 
    return retStyle

}, // END RETURN CALENDAR ITEM COLOUR

 
calendar_load:function() {

        // GET DAYS FOR CALENDAR -- 
        var dS = this.dtStart //startOfWeek(this.dtStart, {weekStartsOn: 1})
        var dE = this.dtEnd
        this.sched_days = eachDayOfInterval({
            start: new Date(dS),
            end: new Date(dE)
        })

}, // END CALENDAR LOAD

calendar_load_day:function(dtIn) {
//this.isLoading=true;
var retData = [];
        var self = this;
        this.sched_data.forEach(function(item){
        if (item.payment_DueDate.substring(0,10) == format(dtIn, "yyyy-MM-dd")) {
                    var obj = {};
                    obj.student_ID= item.student_ID
                    obj.student_lNAME = item.student_lNAME
                    obj.student_fNAME = item.student_fNAME
                    obj.payment_Number = item.payment_Number
                    obj.payment_Amount = item.payment_Amount
                    obj.payment_Rec = item.payment_Rec
                    obj.payment_DueDate = item.payment_DueDate
                    obj.student_eMail = item.student_eMail
                    obj.student_TelHome = item.student_TelHome
                    obj.student_TelOther = item.student_TelOther
                    //obj.number = item.numberv payment_Number
                    retData.push(obj);
        } 
        }); // END FOR eACH
//this.isLoading=false;        
return retData;
}, // END SCHED LOAD DAY

get_date:function() {
    // DATE FOR COURS ONGOING
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd;}
        if (mm < 10) {mm = '0' + mm;}
        return  yyyy + '-' + mm + '-' + dd;
    },

format_money:function (n, currency) {
    try {return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    catch(err) {return '-' }
},


return_pic:function() {
return `data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAG+AYMDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACijPNIWxQAuaQHNITjigECgB1FJuFCtmgBaKKKACikxS0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAUo2dl6nqR196KSJtq9f4ievvRU6nOXqKKKo6AooooAKK
KKACiiigAooooAKKKKACiiigAoooNABRTC2G60FzQFxS+KGfbTc03dkfjQRzDiOaCSapap4gs9FjDXd1b2qngGWQJn88VmXHxJ0G3SQvrOmjyVLv/pCHaPfmgylVSOgLZPSivnD4m/8ABTX4dfDrVLm0+1yXxtWCvNF/qs+xrovCn7d3gTxb4bgv7e+kBnAIidCCMnHWp549zL6zF9T21juoDV4r8SP26vh98NPCcerXeswzpIGIhhcNIMe1Z/wS/bt8IfFXR4r2XVbOwF0XeOJ3wYo17t9aXtI3tcf1mNz3sPinAmvOdH/an8B69fSW9p4l06aSH72H4HOK7jStcttbtVntp454mAIdGyDVm0a0WX6KiS4DL1z05qTPFBqmnsLRRRQMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigClFIjL3HJGPxoqjJE6SuBuI3k9feig5dTbooooOoKKKKACiiigAooooAKKKKACiiigAooooATPFNZiDS5HSmd6BN2A8jmkL4pjvtX8+TXzh+1j/wAFGvCX7PLXWl2s0Wq+IIot5jjcGKA/7TVFWrCnHmmc06iW59Ealq9tpNq013PFbwpyXkcKB+deA/G7/gov4I+GVhdpptyuvajbfL5cLYiVvduf5V+Uv7Rn/BVXxj8ZPEsq3eqNFaLIVit4zshx7KOv518y61+1bPaJei6u9xu5WkCjORg9BXm/2kn8K0OOtVntHc+xf20v+CkWp+LfH7Xd7e/ZHUqttaxSnyogTgAf415tq37asvgvQJlku981zmUuHzuX0NfD3jn4xt8RPGkt9LHs8yMcclY2UYBHpXK/8J3Pc2scFwZJNucDJ+bHofSuBTk22m9TONCV7ydz2vU/2pr7x14kFveyyNZtIX39CxLZGf5V7U37flt4N8DnTY2MTRxCKOWOTLnAxivhaXVJ9Ok3ovyk9CPyqKwtr3xFroBcFFUyZxwMVpGTVmayoxue5eMP2yNZ122lsJrt3d0YhWY4ANaXg
L9qbVfC2lWgbUp4/IJQkMehr5yvZXsZDdSoW81ygXHzYFPj1q4aMtnZBk4GOhHWm0nK4KEZKzR95+Hf2xrp9LicXZhleNGLp/F83Q17t8Gv+CjniXwN4kAs9auPsdwuXSSUmN8fjxX5L6D4+nspDNuk8oMAFY4+XGM4r0rSPjElrbWi72kWOJ2cKeuK7KVZpWkZqnKKskf0Tfs7f8FSPBHjLw9b/wBuSy6XefLHJLjdCT65r6V8AfGPw38TRJ/YWs2GpmHBkEEoYoD3x6V/Mx8N/wBpyRikFtO1vbyBRgDgD8a9+/ZE/bc1v4H/ABfkvrC/wryo24fdkjPYjOK6o4um1Zle3lT1R/QkGyKM184/sjft/aB+0HbfYryWHT9ZVgqqTtjnz0KmvouKUSDK8gjP+TXQmmro9GlWjUV0SUUUUzYKKKKACiiigAooooAKKKKACiiigAooooAKKKKAM5sM7f7x/nRUMlyY5XGD94/zooOc16KKKDoCiiigAooooAKKKKACiiigAooooAKTPFLTZB8tADWIBrM8TeKrDwlpEl5qV3DZW0KlnklcKAAMn9Kj8beNNP8AAXhq81XU7hLaysYjNK7kDCgZr8e/+CrP/BT+4+LTR2HheaWz0CyDqFzte4Zhjc34dq48XjI0I95PZHO25aI9P/4KDf8ABaNJtWuvCfw6vDbWUSFbzVAMPJzjEfp9a/Kz41ftM3uovfTyXE01xeSgB5GLNn8+lcJ4z8fXGtabNhClxOxUuerjOfxrh/Eei3uq26KN2xVBbH3sfWvAm5VX7Spqzj5HOVmXLz4hXOo6jNJJI22OMgAn+VV3hvfE+pxSWqyBI/mVH6njGM1ofDv4errl1bLIZHONqqe/1NfRHwk/ZYumuI5/KxvyVV+eKJVkj28HlcqmtrHi/gz4M3+uzndBJsMhWQbgDj86720/Zohabf5DSR+Qy5HG/wBc+9fTXhX4Bjw87SLHBJ8obHl9CffNdafhtG1mkYUMSS7ADueteNi84VN2gf
UYfhyElzTPix/2bU1Xw/EIM+ZnALnpzirHgP8AZ1n8OeJNksaMIyY5c8qwNfWd78J0srwFenUrjHfNQH4ZeZff6tojgBmY4XmuWnnMpWOv/VmnPSx8ma58AWsnnmmgjeFrg+WR94fhXMeNfgh/Zligh/5bRbwpPQnrX3JP8P7e4iKNH5oXjPA3VkeIfghZatb7/J/1RG0Yrqw2dX0ZjU4Tpp3Vz86774SXMKSz7MfL8ytwAPaubeyvJNUy6FIEXavbNfeHxD+BK3ieUlqyYkOD6qK5bxD+zpZ2toB9gBl8vOSOK9SnmUam+h4+I4crxlaKPlrw34lOgpHbxblT5RukPJPoOOa6jQ/iBNtgdGKXBkLENwMCtb4nfA2fTLjz4lwsRLFcZ59vSvLtS0fULFlIZoVUkZz613UqkZO0dT57E5dVg+Vn2X8Df2nL7S7cXC6h5L2QX90jkDrgc1+iP7A3/BVS60G/sdM8Q6m19oVwMB52LGM99pz2r8PfBvi7+yrG5iScLE5CyRk5DYOeK9E8EftBS6folrZbh5dluWIR8EMffvXRRqSi3JHk+zcUujR/V54I8cad8QPDlvqel3UV3aXKBleNwR9OO9bAOa/JT/gjd+3fZ+Fo7LQNf1J4LOeBkAZsjfjIOD0NfrBo2qLq+lw3cYbZOgdQ3Bwen6V7MZKSuenh63Otdy5RRRTOgKKKKACiiigAooooAKKKKACiiigAooooAwbuYLdSDP8AEaKZe3CJeSAj+I9qKV0c10dDRRRTOkKKKKACiiigAooooAKKKKACiiigAzUUkmD0pzHjFfPn/BRX9pyL9m74B3M0Fx5Oua4wsNOVTlwW6vj0UdayrVVTpuo+hE30Piv/AILd/tozx+KH8D6PeldOs7fy78wvje7HOOK/Jnxj4puteJBjLHOGBbPfFenftj/FD/hK/iBdOs011LKyxyTSP99guT/hXnHwf8MjV9YDvbz3LStjYTx1zXyTvUn7ee7Od0nVmow3K3hT4ZSaxOLeRCy
bgwZmztz6V6PpH7NxudOmgMakHpHzyK9i8B/BjTo4RcbLm3uP7mBjn8K9g0DwN/YsEQiX+DaScbgfyrz6+JcE9T6jLspj9rc8C+FH7LelW92pZWgZSflc88V9AaJ4Rj0WwWGPZ+5IRGI5xWlpXh5Y7vcYtu0kkjqc1orZDh1zgHBya8utjp1Ie8rH2mX5ZylCKyLxtjEa8DB74qzZ6B5Sbig5H8JrZs9LjvcBlXk55q7Hof2ec5KqmAASa82aTSkj6aOFjFeZyMmjp9qDEqcj7pHNSWvhn7SrFU3AgcbeK3Bo4uL/AHcug446iunt7CKGw2JHtwMda5HVSkkzojh1tY82vfBflR7io+Q52qORVFNHYxNxnJz0r0q406Nwd3Ck4zjk1kTeHUdWjjXndnPrW0fY6cr1On6soqx5xrOjLKjoYVk+U4OOma5jxB4aePTNuFl+Xaox0/GvVtU8HSwXMv3cE5JA4Fc/qfh+RGZdmUjbt3rLmkp7nFXwsZI8B1z4f3DSSxRogkVN7Bh2r5+/aH+FUE+lLIsX2dEk+cqK+3te8Lia5kmxwTlyR+lcL40+ElhrQkWS186CReUx0PrX0eBzJUtz4/M8mjVvNLU/OLVPCIsL2R1IJU4RVBww9c96qWtwbZyiuIlQlvdWr678YfAqzS+zDaNCrHCKV4x/SvF/jF8CRoly81nb3JMgIkITox9s19Dh8ZFu6PzvMMnqUpPqdB+zX8WLvw74k0xopnMomX5mb3zX9C3/AATK/bjs/wBpP4bQaPqk9uniXS4hHtVh/pUQ4BA9R0Ir+Y7RLq68H6zCTujEMqtyMEV9ffsyftc6z8LPEGk6tpV/LYz2EoltpEAG/DZKsO4Yda9qjiuVJHgT9rRkpI/phEmR+tOrxj9jH9rjRP2sfhLp+sWU6R6kIVW/tWIVo5QMMceleyqcV6h6lOopx5oiDl6fRRQaBRRRQAUUUUAFFFFABRRRQAUUUUAc3qNorX0p5+960Umqvt1GXr1oqdDkOloooqjr
CiiigAooooAKKKKACiiigAoopM80AVdU1KLSbCa4uHWKGBGkd2OAigZJP4V+Df8AwUn/AG2W/aK/aQ1rUre7nOh6FJ9j0yHOBGiHa0mP9p+/pX6a/wDBZf8AaLuvgH+x7qaadP8AZ9S8SSDT4n7qjD95j/gNfz5/EHWTHf3hLOWunCl92cqOleDmdT2kvY9Fv6nLVm09C18RtSttc8bSiHLm5w7gjI3EZyfrXrn7MHg6W4u4HRGO07iduMfjXhGgXpvPEEEynMjOB8gzuwMDNfYH7LsB1WVfMZlxHgDZwDXjYmT5FFHq5NFufM1qevaHD9gtNhCoWZTuI6+1dLPu+RnbD5zjGBUE0EYuIwqoy7AQcd61re2+1GMAA5OGyM183Vm2uSJ9/gqOzsQaSHuG3bsFBnmuistGeSLLpgd/eptH0aIyeb1UnnjFdHaWqsT65xjHFTJ8qvufUYTTRFCPSo444/3RxjGSKGtBcxlsZ5AGRz+VdBFZRSRHl3cDIGOtWtN0fyx84PXI45Fcz95Wudys2c3c2C2VqHAILjbtA5+tLDYtDaFo0LHGQpOc10t1o21W3DKkcEDkUWmmMsfyJ8qjO09a5JUpNm8ZK1znLSzmuNPLsPKkz0HaqV1bPFjbtwCM8+tdXd2boPlQ7WGSKzLi3CSs+CQWA6elbKlJI6FrsYGp27TRP8nOM4B4NczqVksRUcjJ/Ku++yqj46Fjxms7UtGT7UPky2eMmhRSleTMJPl9w861PS41VlZGYn7wz1rnr3Qo4Z3kKkK5yq5xXofiDRnN6gX5BnB461ka5oxMRXGcjbz/ADrqp01Ug0cFampRujxrxRocEupMWV5FYdu30rx74z+CZf7Fkmg37l+UAc719TX0V4p07yjtb+EHaD14rjvEelwXelbZmAUnb/8AWrXAVZUnynyePwya1Pgj4h+DRFI0pMZl4LEnI4rN8LeK4/D97boE88BtgRScLgYzmvbP2gdEs7O/nkkhhigx86qMBh6ivle/1Gbw/f2s1
vKqwRs5GOS3OOa+zw9Xnjqz80zTD+ym43P0f/4J7ftx6l8APiLo1zZyTiPzCJ0P3XQ9Qw71+/Pwk+JunfGD4eaV4i0qZZ7PU7cTIynO09Cp9wa/k58A/E6W20iC4YnzfNx8vLYr9qP+CDP7Vt1qE114C1KbZZXsX2vTI5DkrIBmRQfTvivbwdZy92R49Kao1Eukj9RqKM5oruPWCiiigAooooAKKKKACiiigAooooA5XW4D/akv1H8hRUPiK8lg1mZVPAxj8hRWZyHYUUUVodYUUUUAFFFFABRRRQAUUUUAIDkUNyKAMCs/xRr8Phnw9eahcHEFlC00h9lGTSbSV2B+Tn/BxN+0H/auu6V4DgH7rRY1vbk46vL8q4/CvyT1oLf3T25jZkK/ez0NfWn/AAUW+My/tCfFHWfFV40iyapcyrHGTxFFFuEY/TP418keH7ea+1A/MWEw8uQejeua+UcuepKcur/4Y45RvNJHRfCjw29rqKxAsULghicda+yv2atJNjo7xBsO7ZDbuteDfCzwazSB7iFsQxjZjocV9IfDARWVlGuPKZl3Y244rycbVXQ+0yzCOMFI9T0jSIv3a53L1PPT2rpLZGJVseSMY61zmkXCW1uGi+d35PFdFZ3gSyw48pXOMf3q8KEm1qfdYWF48xt6PZKy5LlgTlR0zXU6fZRQjAXPzc1zWhMTbMVLMF+6cV0GmmdCmyJm+bBOetauKcbs9GlBpXNizRYXJZDkDA21t6XBnCtHnIyCR1rPtGCsGZTuxnGetdHocyGIAxg4bgjtUx5eqLqTaMrVrb7KuJE37jkcfdqSxhVkJKhRjBBHJ/GtLxBcQ2sQmnhcndhQp61esbSO4st6RvgjPNbU4qbsiPa+7qcxe6VFJN+7j3hhgYrOu9FGzaYsFTge1dpL5du4AhDH+HI6Vl6+TLD8gznkY4Iq6tG0TaNaV9DhdU0wRq2cE5+mKytQ0tHG4kHAwoBrqL+ASRHcuW61kahD5cG0fKw6E964OVOWp08zep
yt7C63A37CMbgKwtasHt7rdsbpwa6jU9Ka5kTMnI7isbWrffGD5jHtit4aOyMJO75TzLxdov2mfO0dwSeozXn/AIh8OtPYzosm90csuOmRXrutbLqSVGUhgOcnFcRrkEAtJViACrksQeeaylaEuZHm4qnrY+VP2gtJ/tPwneCa3KyqpAkPQY9K+IfEQljneOWE5jcqAPY5r79+O8jGxuIsAxgk4bkYNfDvxngGk6y7RqhWXLoydiTjkV9LltXmifmnEmEtLnNLwU7zIY0YBYxvbjBr9K/+CHOuy+K/2ltMt7a823lnBHd267v7rhXX8VNflx4WuZbO/tXSQbHi+YE53Sf4V+hv/BFz4mWvw5/bG8C3ZCxpcXTWUrY6rIox/wCPCvosNpUXQ+GlZtX6H9Gkf3KdTUfcgNOr2T21sFFFFABRRRQAUUUUAFFFFABRRRQByXiIE6zN07dv9kUUniGLOszcnqP5CiszladzrqKKK0OoKKKKACiiigAooooAKKKKAEDZNeU/tt6hqGkfsseNbjTGC3cOmyEE/wB3gMfyP6V6sFxXMfGOGyufhbr8epJ5lg9hMtwuM5Qoc1hXu6TE9j+ZX47X8t1YSon7024Rgc/dJyGI/L9a4/4c6NKsa4kJ3NtG7+P2rtP2lbG20bxpNcWyypZzyywonTKb2C8Vk/CTQZNU1ONEmUpbuDED2J718rRnzx8zlStW0Pcfhl4QvIbCEzqSqoMKvU17J4R06S167ANuAB1A9K5bwdpq2NmnmEsYyrIR1Jr0PwdK1xdAylPnbC4HNePj1ze7E+5yxOEVE67wnPDsTdlcADB4611MemLeBN4HDZXmsjTbNRd7ZMbWxtPpXU6ZEpXBTPPX0rzeS2lj7XCv3TZ0KxRIUUL0OAcdK3tPgMxMeAMdNp61H4bgElsQFzt5rcsdJlkctjai++K2XK4tHowmuXUjt9N2kb4+QMfWtTTmkM4V1PyjOD3HrUsWntdeV82eecf41owaC1zKWizv6de1YxptvlS
uwlNNahLYCeLDruCjKgc1c02f7NEiFfmIxjtUdtYz2cWJ1dc8LxVGTVGtpGQbjuGRkdK9CnaFnIxUedWRsNDHJg/xemKyNd0yLy5XG7O3Jxxipobn7S6NESNoy4J5FOu4WuYfmUSfLjk1VWcZR9wI3i9ziZbITszc4X0NZl9ZteBwRjAyoxya7O8sHYbFGEIycCsrUdMIg3YK4GHPeuCpTvudkaumpweo2bRMw5AAzmuV8QNOb/8Adqw2NyMda9G1CyEeU4bcMAmuU1fTkErBkGexz1rGG7T1Ic43948+8TyM8W4ooPQ5/wAa4TXbXykdRlSzfMSflP416R4/g22HlsUCseMda4K6G632yAkEEDNDhFnNVknHmR88/GDRXvPtUZlVhnoP7tfDfxgsDZatcw7G8wsxxj7gBzX3v46vLeS7uiUVeSAe2M4618qfGTwlaDxBPPNuCyq6hsfrXuZb7qPheI6M61NvseD+ExL/AGgjyHf5ZyoY/dGcV9s/8E19Fk1T9ozwiiec0zajbrCqHq5bivjRIE0/U4l+U5JjUg5BO6v0K/4I4W1vf/tkfDu0uvljTU45TIFwQ+07AfxH619RQs5q5+aSVpWaP6MtORo7GIP94IAfwqemIfl9qea9o9ZbBRRRQMKKKKACiiigAooooAKKKKAOS8Rts1qYY/u/+giijxNatJrcxD4+73/2RRWZg9zraKKK0NwooooAKKKKACiiigAooooAQHNcr8bbqOy+EHiiWbaI49LuSxPTHlNiuqHArzP9sKOWb9mPxusJ2yNpM2Oe23mufEO1KT8hPY/nT/aPhXU9RjEbiY7chR1ByT/Wk/ZzvoJb8r5BEiMF3svHFYfx31Oez8XNJausqTQrIuOTg5/wrp/2VZl1vxDbwNHkoC2f4a+Rw0X7NIxhVvWSPpa2scQosS7SwU4IxWlBrcHhi53SfKSwUfWo9Y1ZPDOlzXUix+VAoOX46V45p2vaz8WvHO/TtRR1jBAiWMupB+lcM8O3e59vgndK
a2PofT/Gk1xLufZF8wIJOMj2rs/DHxQ06K03XVxCuDtyT8rfjXkWj/s7+P8AxLp8So1paW0pAaR2+dAPQVvD9jPXrq3KyXcMmxt2FLBTWaoJx95n02FnVkt9D6N8GePNL1Wx3W13bzQ52M8T55xmu70XUYb2xMaTxSEjOVOa+H9R+EPjP4PTS3dnG0sQfzDDC+5cYxnFdN8NP2n7u28Rw22r77GSRSRvQqOKp4any2g9fM63UlDV7I+2dHgRLbaygYHB6Zrd0K7toUfzAPnOARwa8D8HfHS4uowGkiuFcYVlHy13ula+bkK4ON3zDuAKcJxi01/w5pyKrHc9jtdGt9UsWJi3SZzk/wANY+teArfUrlGt1YlTtIA71neE/FBWJI2PysnJrf8ADGtjTZs5HJwd3pXvU1SqRsefKFajJuLM0fDhrCYbk2ZIUsR1J6VNfeBf7IjxM3OOgPSr3iDxtLNKsSzYCuNuB3HQ1gaj4ne4vRvlOGOGJ71yulShoh05YmbTkypqlhHaRFlXcTnn1xXL3BE2VCFOMgZqx48+I1l4dsGkmkXuoC+9eUeIf2gzpVz8kCFXUlSSMKB3JryqkVOpaK0O+EpRjqdXrukgReaHG7+IbulcbqiI8DO7bVU9SteVeOf2wX0vUSqR24ibO5ipIFcZq/7Zc01s8dvpZu9z4ZovlX9TUSwXL717GTxicrJHeeL9dinlfzBkIT+leb+MPEEMNhJtljAOeM8gVy+qftSadqsr2k1jcK8zsGZIs+WPXPevLPGPxHl0zUjJC8dxCXPysOiisZ4B/FHVG/tFJe8rGxrbQSfaYTICCCBnnGTmvnz9obTxaS/u/nL/AHQehr2TSvFdj4rSWSInMi4eM9QfavIP2glnFt5qH/UnAJ5zXVgoSg7M8DM4qdKdmfO9jZrDrsXmKDtcuFHQEnNfSf7Lnx9n+G3iiHULGZlvbGZblJYfvrIpG0/hivl7XdUxqxDyfvdxK811fw28QvZHyopPnmbBPfOcYr6Silo2f
kuLppydmf1q/sqfF0fHb9n3wn4r4MmsadHPL/1024b9RXoiDAr4n/4IP/ES68Y/sOadp15Ks0/h+5e0DD+4TuXnv6V9sjpX0N7q6OrDScqab3FooooOgKKKKACiiigAooooAKKKKAOV8Rk/2zNz/d7f7IopfENvJLq8zDocdv8AZFFQYPc6miiirNwooooAKKKKACiiigAooooAK5f4w+HG8XfC/XtNUrm9spYvmHHK103mV5942/aP8EeFNQl03VNdtYZcmOVeSEJHQmsK3LyOMna5UYSlpBXP5pfjky+G/EmpaZJIjXek3ktiWJ5wkjCu7/Ydt0ufFRP3Sc+WrHkZ9q4r9uJ9K/4af8fjSJhcWaa/ceXPGN0bKzk8H3z1rd/YduHufip9nkKncFWNgcYzXy9Cm1TXcwlTUavMtz6R+M+i3Xia4ttJiRgjsGmbOFKE4r1j4B+ANN+G+ixC3tIYriQ4ZmQbs/hUV7pKWsRnaNWk4xI3LcHNY1/8VLXw3ef6Tcw25fLKZWxux1x7+1efNt1D7XJHf3XsfQeha4sdvs2bcjA9jW7p2r/6OzjjK425+6fcV8ZfEv8Abr0z4fWwfTc6iqrvuACE8jnGTnrXmlt/wVY1K3nnjNhM8GQYWiixvH9057+9UsPUk7o+weLw1OOsrH6C60sdxCWJGT2PT2rznxj8K9O8Y3KTSWkTTxZw2AK+b3/4KWf2p4JW83Np8hk8lrea0LF+cKdwOK9B+F37UOo6/YNPqFhHc2zMAJrYjBBAIPr/APqrKvg6sIuUwjiaVWOjO38PaNP4EQws8ptg/GeSK9X+G/ih9StwnnZHKqPYVws/iS017RWkgO4sMjvzXHeD/iPP4L8arbSy7YZ2IQZ4rhjCUHHqjWnFL3uh9deH7ooycgZ4/D0rq9D1COTczFSccE15L4d8QfarWPDkDIYZ+ma9A8P6r5ukDHBxnBr0MNinbXoFVKceZEmt6mItT+XDKWI5P3cVzniTUid2JMELnr29ar+JfELWt8
xUnKglq83+IXxQMMT5fcT8gBPUVzfWXUne50Qp8seYx/Ht1JrG4tNuKtlQTjHpXmep/Bm58X6on2vUrpYAxLLEcA5rt/Dtm2uus1xxGTnBP5Vd1nxdpXhssJriOBUXO4sAB9a153eyMudS8zmPDP7LHhXT9QWae0l1CVM4NxIW259BXe6H8CPBsFm6RaLaeaed4T+prg7r9qHw7ZXqJbyS3byEDbCuc5OK2I/2mNA0nP2l7i1QP5RZl4VsZ7V2/vZRu1oc0nTvyyNXX/gV4cEBFrp9vE7ZUlI15B/CvCvjH+xZo+rW895p6rHJtZmiVfvH8+K95tPibpHiW2Mtpdwyq65XYwJ/LNY3iDxCkKzfP8m0gNn1rnlzc1l/kawo0rXp7n5h/E7StU+D3ist5DmKF9uxVwwO7HrUfxM1D/hLfA886CQSSJv+593619OftJ+ALDxppFxNsWRy3mKc8Z+tfM/jbRpPDvgfUYN6iaFSQd2cj0NXQlz/ABHzGZ3i3GGzPkHxJatfaluV2EkcrAt2rp/htbTX/iy2DsrbJVJz0fBzXN+KdXhzNCka/M7HIHNd3+zn4Zutc8XWkMCPtcjaR059/rxXuU03Gx+Z1Vy1W2f0U/8ABvxpFxb/ALJN5eyblj1C/MiKR90DIH8q++BXgf8AwTR+DEvwK/Yw8EaJPn7Wtgs85YYYs+W5/AivfOgr3aacYJHRh1aGgtFFFWbhRRRQAUUUUAFFFFABRRRQBg6sudQk5Pb+QopusyhNSkH0/kKKizMHudBRRRVm4UUUUAFFFFABRRRQAUUUUAeS/tgfF9/hD8J5p7eRo72/f7PCy9UGMsfyr4Bl1G38atOtxKSJjtmLvn8T3r6U/wCCh+vHX/H2kaL5j+VZxB2RehdyeT/wEV8V6h4iuIfizOtpva2iU+ZEEBE7A4wa+LzrGL2/K9kfqfC+SpZdLE/adz8wv2gUbRfjV4utvP8A3Fnq06DnJI3cfWvR/wBhqeK5+LdmsZLHI3gdef8ACqf7ZXw
0lT4v65qSWAsrTUZROokHzFivP1rb/wCCdXga4k+NcVxiTZGGkc9sfWt8FW5oXPzzM8K1immj7Y+LGqLpUIVHCRonzHPSvin9rL4qr4iC6dYtK07y8iNSV46HNfbXjbRV1WW7gMXmRzggZ56V4T47+ACXUiTQWaBlJJC9eK851Yxras+ry3BJUU72Mn9h79hfSfHOrRX3jwT3086q0Vk8paMqeeRWx+3/APCVfCfx2s7TR9ItbLSzo8cVhFHEFUyfxDOK0fhZrfjP4e366np24wxkZgIz90Y4rvPFPx6vPjd4Yt7bxT8PmmmSTYlzC+yWI+3Fe17WFaPLFpHm5jlFZSdWk+b5ny74V+EulwaP4YSPT9Si1iKWZ9Xe6nDQyLu/dhFBxx6196/DP9ip9R/Zj8OeIYoJNO8QeW7Tx4xHcxhjt3D/AHTXlnwh8K+F0ddd/sO91g2t1s+z3FyVWIK3IwOtfR/jT9rDX9Y0VNOsLK30mzhi8qKGOP8Ahxgc1dSnRjSfM7t/cPL8Djp1VJ6fM8o8BW8nhPxm2mXES2F6YxIbaSQOJFPRx7Vwf7R8X/CNeL7a5ib95HKqEoeRk4rpJfC2o+INYS8vJ4oik4m82Nf3rY6AtnpXKfGu8ttUtorbeGmEqu7BucA5618/U5YySimfo1DDqK5JO7sfSfwX8UPqnhi0nYFN8aj9MV6zaaulrozBSFbqCRxXzF8CNWZfC1sMklVUKM9a9eg8RSRacCznLcMG6Gsp2i211OiGHUVYn8e+KjZ2nmnbyDvI9q+aPF/xAm1v4gQW4nPkyyDaMepxXpPxd8YXGnwzAbWyDhcdc14TpBi/4Sa0up9sMhPDLyBlqyp+7G7RniKdo+R7Br3i6407SJI7BXMix5YkcA159N8OtS+Kus2i6ZDLrWpzOEKRPmC3ycc10mvR3zpBannSnWRrl4uZJPlyAK9V/Zl/aY8HeBNBs7G70x9JMaMnmR2uGY5z85r2MupxqO70PGxka8cO50HqfBn7avgrxH8E
/idc6Rd6i8T6esMiRWh8lBvX146GvM/H/gnxToXjubTJ9cUT29jFfk2d/wDaIWMg3DOD97Hav0c/b4+AXhL9q5LXXvBmsaXfa7NB5U+nXkvlPcqvI27u9fKPhb9kXWNe186eNKsfD63MYjvdQuLtDsCnHBB9OK9JUJxqOMdvXQ/PMVi8S9LO/ex5rqtl8Xvgt8M9I8a2039ueH9Qi8yW4hQrLZj/AGhiu1+Dv7cOm6rpXka1qPnXEwwso+8DnGMV9XfEjxl4E+E/wNtPCMWo2eofZLUQGJW8wOpXbkjnvX5oeKvhkPC3xXkvdAtgLS4kM6AL8kZBzgjtWWOp02+W57GSyx7h76bXmfVPibxNBr8AMbH7PIudvTP4dq+dv2hD9g0rU0XGPKYllPSvR/hpq9141tlSS2NuIx+9J7j1B4rJ+OPg6C40fUUJTy5bds8ck15EVGnV5Eepj0+XmZ+e+o3EX2+JXOMu2TX1z/wSd0jR/Gf7XHgbRdYurSz0i8uTPdy3EgWPyosyEfjivk688PhPFbxHDFpSiKeMEnFfTX/BOj4VRJ+07Yzavcrbabo9q9yZev7zkrHn3zXt06sYtOx+cfUZYrEezfV/gf0ZL/wUo8A6NfxaZYWep3Npb4hSaOMImxflyAeoAxXv3grx1pvxE8N22q6TcJdWV2oZHU9OM4I7Gvxx0XxJ/bGrG4RUS6nX92rniKPOV4r7f/4Jk/ES8t73UPDd/KWW5iF1AueFdQA2PQHP6V04PM3Vq+znY+1zbheOFwSxFJvS1z7Iooor2T40KKKKACiiigAooooAKKKKAMjUtLa6vXcHG7Hb2oq/KCZDz+lFBg1qWKKKKDcKKKKACiiigAooooAKKKKAPgb9tvXGf9omVgyYt2IIB5O2LCj82zXzVbeIbD4WWsup6q0X2ySXIz/y0YnPFe6fty+JLfw7+0FrszxvNJa73Cg4Gdi4r8+fi3rfiD4z63PextLb6VbnbEydAR6V+eY+LliZep+xZbjX9Qp0afZHm
n7X/wAaP+FgeN76K3SM/aJQyccRgDHFe/8A/BPz4Qp4S+FX/CSXK5ubxmEYcZ3DOK+Z9T+Fm3xXCiCWTz5MPcSctj0r7v8AA1rb+Hvh9pGno6LBbW6ghP72MdK6cPOEaXLB6nxub4NvEKUlqPN0kl20m/fljnHYntWdqmli+yU+VsEnn1rU0vTjcwMVI3u3GOy/41p6d4dFwM7h+7GG3dzXn1aTlI+sy/DKdJJnN+H/AA19hiLyAR5z365rptJ0i0Vo9oZmVtwIGBmrNvp0cSchH5wB1pdMjnguPl2lfT0renHkSiz2Y5dF7om8M+Are00+6hs4o1N3IXwo5yTk1uXvw3uZLZSwJKqEYE5KE1L4ekLtHKv3kJPPbHvWvqPjtdEiuJFDTTTIyFcf0rrp1YNtSZn7FwdqaPI/ilq6eELLyU3G4wVjUDrivCfH93LLqkUTxoZb5xuKnhVPr6V7R40szr179vvRzuLBR/DmuOfwXHqPiTzZ1ULkBMDjA9a5qsmpcyOygrVlKfb8T0v4V6UNJ0y2hA2OoXJPavRESK60o7y25Rjd/wDWrkvCtqsVtEFULwuWHSts38kpcL9zdg+1ZT1tY9P2Dmk4nH/FSxTVdIuVDbnVCFZj0Irw7SL19UjubAsVmtj5itt6AHNe7+JpI/OnT5tjI3y9TmvHdf0FtP8AFq6pBGy5yrkDqPpURqcktSKtCLTUtz0H4beJo/EVutlOpM8SiKTPVT7V1R+HlxAzKEBiXJOQMkn1rivDmiK2pC9iHz4BkPrXrfhDxdHqtlcecAk+SuWHBUdq9XC4iM46aM+fxE/ZfCtzntQ+H1tJpsDyoIpbcmRZAM5OMYz1rzvXvgPb3lkbfzpWke2KsCxG5i27Of0r2rVtTgV9hBIzgoRwawrm8jlmMaYDgfKW7H0rZzlaykeS05ztY+c/GP7Plto9qywo00mSc7iWwf4c+may/D/wfitIpnuohtKkAMcE19GaisHlfKFLH7564PpXJ32hfbLiUspd9+QDxt
FcMpuKsmdtKlzQ5TzPwR4BgtWLxJ8jowcY4XHYVxnxc8LQ+ddJMB5bp5eQ2cg+2K9/t9M+w6awIBz1BGK81+JlhFqclwpVdxQbCORn0rz6d1XcpdTz8zg4x0PzH8f+FF8P/FC9hmikj/ekoxHVQc5FfTP7L1lYx3mn2lvdRQQTENd3Ehxlf55qf9qX4VxXt5DqMcKpqFvbxlti/I4JI4/L9aZ8EfgfNqVib6G6CzuF2Rk/MB6Yr2lXtT0PAyjAP617S2n5H174N8R6TD8XLf7Os00bxLAu1TtbHQ/Svur9iiMn4/WLRW5RUjmBIOAoMZPT64r88fh9FrPgr+zBcxTXBtJVMjFM5QHBGa/R/wD4J23Vt4u+Id7qlplohA7rn+EHC/zyKjLFzYiLPus/rU45ROHZWPtCiiivtT8QCiiigAooooAKKKKACiiigCCVgJDRTpEy/QUUGLWpLRRRQbBRRRQAUUUUAFFFFABRRRQB+UH/AAVV1wad8Z/GSK3+kXXl2kJ9N0amovgz8L9FtfhRo9lcWkbSfZE80MPvNjJroP8Ago58OX8VftYTRsga3nvYPOPopUH+lYum6+/hTxd9nJV9PjYRo393jFfneMU515pu2p+w8MSgsLDm3PLfjb8ErCy8XWX9mWqIV3TzdwoAzjFdNawx/wDCM2UqiNgYwwWP64rsrrQYtfm1WWRgZXciLnJMYGK4nwlA1p4Wlst/zWV0z7h94KWrPDyXvRZycQKLrqSL+mRxyow/1Y3bwAOa2baNrmRYYkfYx2sx7tWdotopuEkVy+04YEdq6SxgjTYUWRsndwMYNVze/oexluyaJI/DOyFV5DA5zSL4ZlLiTlPXtmt3S2+1r0wM4y3FaAsFkh6HCnBOc5rP2nNKz6Hue0knqYVtpr2VqqqwGAT0rG8QaWYrPzEPzgk7s812cESFmU8tjGMVS1zRD9nKlW+YZwO1ROfKmzJpxd2eSa5GoiYP07ZNZHhvUbfWLpmTJCuQxI6YODium8UWkdqzxMw
80gkZHSuW0jULS01me2VBHLb87SuA2Tk100ZKUbvc55SipI9O0e0RNPXy3GAAc9jj0HenT2/lQlWXaZBgbawvB93ObwyNnywPlT+FfpXRXWoBIixBG7oeorlxE+WW59BTdorldzjdVR7Rp/M2NwSo/i5rmWtV1UI8q7drYAHQVqeOPEStqRVcqCPlYd/xrktM8XRwX+yV1PXKA9MVw1MTdq2xxYxNO51fgW1XSL1jvJSXoGOcV3L2LwQC4UxiRSW3exrC8MaWmqFWjKlmAODXRrplytg8TLuQtg8/dFepRlDlVjz6tONSFr6kcOqmW1Ek8RY5+8DS3RjFpKUjHnAhskZxnvV630xLNo8pgNgYb3rUg8JwXU3y7gi7XkHqa6JySXkefDDvZdDk9Q0YeQMKQsx3de9Z1/oUdveyTeZ8xX5Vrq9b0wWUDNsKkngE5xWXqVmkkCyt94jc2D0rmlU5rJHpUqMeXQ5XxMqTaXl/kUKdxHHA715F4j06P7WUhdfJKBvlPPNeseJbYG2fhSrBgAe4ryfWrBv7YYoNm3ChMdhXPeTqpHz+eRUae5xfxF8BN4x1HQ7KOUGYo8SjHGCy9a9N+CHwIfwhqIU20huUcRhHHyZHtXM6Z4C1LxhrU+oWN39kufD9uJAW5WVmIIX36V7cnjDUJ9MsNVMYS4jiVZVA2/MOvFeo58sdWTw5h+dWvud7ofwf/tSwuXlMasE2KoXvt5r6G/4JReGY9L0PxHIIfJezkWzb/a+ZmJ/lXz54F+Kkl3EJHzluWUr0OMV9jf8ABPLRhZ/CfUrz5f8AiYalI+4D72Mf4125NTviObqY8Zr2WCcU92j6Booor7A/JQooooAKKKKACiiigAooooATGR2/Kim7c96KBD6KKKBhRRRQAUUUUAFFFFABRRRQB8O/t/8Ahkaf8cYJNm3+3LdHRs9TGCDg+vFeW+GvAUWvi6jUFBuBJz3FfaP7XnwFm+NPhjS5rBIv7S0S6+0Rs3VkKkMo+uRXytoeh3fh1541
jeJg5R1IwQR2r4rNcOoV5NvfVH6NwziYVcOqaeqPKpPBereAviM4eVZtNuYyoHXYfrWNBaR2/iO/Rd6mdTkY4wGr17xFBPqiPuXAHVsdDXlN3bXOj/Fy1guEYxXCEJkfKcjGa8ig/f8AePQzihN01J9Cx4eigW4GMgICMZ611mlqIXBY7e2BzXI28Qsr2aJlJ2uwOD0rq9KkUbX2jGcYPetpwvdpnTlFW9Na6mtE6yLvGMbsYzWosRjtMqQUJzjuayLCIyFiu772cVraHH9qm2AYmjbGG6VnSp73PqKbSimWLGxjlj3OEDHpjvUev3UdnZ7mUHjcV9Pxq/fFEKdincHpWF4mu/t1k+Cw42k1ji6atZ7inLmlZnz9r/i1tc8f3cEQz5WRgjpVPTtPW+8fySSoRIIlQrjgitnWrOHQviJKyjCzx7t56E+lULTVIrHxEbo8ySEI2R6VdNTaSRwV37+1j1vwh4fe4tkSOPG7nBHNbl38LrmW3ZvInEecn5cgVm/Cn4gDcssTQN5LY46j8K9A0v4x3ulXLt5kUiZ5VgCMetdscFTmrz3PQVaoo2p2Pnn4reCFtJioGyQHK14jqlnNpviqOcjaqSEPx1Br6o+JOtWN1DNe3BjGQ5BHvXgur3lvq2ryfZ0ikAcYJ7E15c8E03JbG9XEWguY3Pgp45l07xo1nIm5JlDIzLkYHpX0hp9tBqunNIUBZz2HSvmL4Q+G5bz4kKxkkYKhZk/55kfyr6O8P3/9lRInPzHOKUYyi+VnBLllPmS0LMXhM3GprgEAAfL3WpLy0aK7c/6sOMgAY6Vv2t0rWvmbVyFwWH8J96y9f8zekgAZcHcCtdcbtcpdO7kYGtSFwimMO2cnvXNapIsCSBkfAXBUdRXTXdyjqSWw49q5bVr4JebWY8/M7+1Zxhyto6JaRscN4xh8l94lOADhfrXmviTULt9ZXyIsfeZt3UAV6R411ALAWRwwQYPFcJNpkt48t1t+/wDKnv7V04enzSufKZ1UjyWZ1H7Pe
kLDbavfXc3lwl1kCnpkdK2b7VX1zRjDYKWMkzSFs9jVzwj4Dm8T+BbfSrSdrb7Y26dkHIHpmvQdN+CGn/DTwU/lyFhHFufe24ladaP2YHVkslTo+0W/Q5TRdJ8nwe8kJU3zyiJFByW9Tj2r9H/2SvC3/CI/ALQYNuGmia4bn++xI/TFfAnwW8EN4w8b6dpdqJDPeyhY2I6Bup/Ad6/TjQNGTw/odpZRYWOzhSFMDHCgCvosko2vNnyXGeKb5KLeu7L9FAor6I+DCiiigAooooAKKKKACiiigBjYJ6UUGPcc5opaiH0UUUxhRRRQAUUUUAFFIwJ74/CloAKKKKAGFa8i+Pn7OUfjUy6voyiHVwCZIgcJdfX0PvXr+2jFcuKwlPEQ5Ki/4B04TF1cNVVak7NHwRr2hTaVqT2N/bvY3MRw0MgwT/jXO+JPBa6rqtldeTmW1J2nb29K+/fFvw30Xx1EF1TT7e7K/ddk+dfo3WuP1P8AZQ8J3cLeTbXFvLtIVkmPH4V87VyKtF3pNP8AA+3lxhSrUPZ1oNPy2Pzu8YQi08QzF4tqs5YZPY1J4d1ASQKrdU+YBuwre+MWiRWHizUrP5WksLkxc9sHGK4a4m+xTBo8eY3yle2K8tv2dkzXKq6TTWx6FYXHG0LnI9cVtWV0bdssMEgE++a5LwnOrWqkfO+MHvWz/aKtOu75BgDnviuOq5R1Ps6VR2Npm+3hSC/C4qnq8MX2Lb04weetWGuBZ2BbgjGQe1c/quogEZbPGSKx5uZ8w/aNswPEXw+tfFe0zxsZozlXiOGB9a4vxH8CbkalFJFcT7W6qH7+tekoZI51LYxJyvvWpv8AMlHmYHcYrrpzaeg1dSPJdI+F2ueDwXsZZJ1Ay6O3zH8a3Cl40eH+1iTPPlxFs+2OK9d8KxC7+Yx9Ttya0rWzjkuyjJG2OSe4PrXRCrJS94lc/NfmsfN/irwD4l8SSpHF+6tsEedI2H59qoeG/wBmK/tvMna/ZH2j5+N2R3r6H8V6ZskK4G
GGckVjmX7DImPnDfeA5rlq4jm922hPv9Xc4v4d/DKHwVqM83mm4uLkje7HPSvRLbT4by0yoy+3CmsI6lFHNtIK85HbNaNtqX2a5GGzngbelck6j5rs6dbWYngy01HSbi6a6uZLiOaXdEjniMegrbv7n7RHzkZ4K1Wv7pYoxLHgsBk4rOl1Y3MW75twOSoraOIvLYlVXuRa2Y0VyqKGzj5q4jxM3lI7na5zlQpwNtbvivUpX2sFUR9W3DFeaa5cfa9Su7iOR5GZfLVGbCiumk4ud2YzrOPvyMDxZqU1xZlQyjLjaucHmregaE83g6+NtHvut0flZ5wc4NYt9YtdeI415TaVY/NwOceleyfCzwZ52h2reUFWaZpgTx04Oa6oyjC8tkfI4yftasY+f4HSeAvDY8L6FB82TtzkdaveIIbrWLEWmW8qQ4Zupb/ZrpvBfgnVfGGqLYaXYT3b55KL8kf1bpX0t8EP2SrTwZeRatrrpf6mnzRwDmG2Pt/ePvV4XC1cS/dWj6nuY/OMHl+G5HrLokYX7Fv7OUng+3HijV7bydQniKWcLr80EZ7n3I/KvohRSrHt/wD1UuOK+xw9CNGmqceh+SY3F1MVWdapuxaKKK3OUKKKKACiiigAooooAKKKKAEFFMMuw4ooFckooooGFFFFABRRRQAUUUUAFFFFABRRRQAUhpaKAPz0/aw8LnQ/jh4lRY5Ns1yJ89AdyAj+f6V4tqFkY5BIUOAeSK+t/wDgoN4Qaz8bWGqRx5TULfY7HoXQkdP90/pXy/rsX+jnGY16mvhMwpyhXd+59plE/wB0mjZ+G6JLb4Cr8xwBWnf27xyqh5Ctk5rlvh9qiWGrRxO5/wBZngV6L4o8Nw6/bqVkaP5cjYa8bFVeVXex9vhZ3hYxdT1kxWrIZFH91e2PWsi91KJz5jGMYHzHNZPxT8I38Xh2f+y7vy7zYXV5AcAivkP4hfGXxx4f8Trp+rXzIg43xL8prfAwjVWjO7DYR1Z2UtD7UTULXylke8ThsDL
Ac+lVb7xzp8F75Zu4gAcq+eor4ds/jaVuI1vNSupsNkgk9avD4w2T6m6f2tcIrnEYkPIFe1DLFf4j6fD5DF6udz778K+OLC7tHgjvYFKnPzHHPpWzb61vzLny1xgsx2g+49a/P7Wfi2EYwxX5SOUbkKP82feuy8QftNXVx8NoNEk1fUp/JdJEjcjbFs6YbG79a6llkZK7YquSVIyXJrc+tPHHjK3uAltBeQtcPkDJ6Yqhp88rJtZkZgMFlNfKXhv4wXGrWzyNKd8Sbss3LA/yq34m+LN54QuUFlrhntrhAz4PKE9utcVfLly2T1CrkzUfZp2aPpq+sPtKs7ONv8PqabaQeTApLnaDwQa+Uv8AhsbVdAjWG6UToD6gNXVeE/25dG1SSG1uLe7WdjtKqm7HvXnPAT+yeHisDXorm39D6otJhHAnJ2uPSst4yL47ZAvOAAPvVzvw4+IUXjKyWaPzUCjlZF2lfwrrIbYX11H5RJKnmuasnDQ85SldWOU+Kd69toe7fhUGH4615/p2jPfQbum1tzPjIPtXo3x4lGn6b5TcMyYAPc1xemWJg8O73Qgu2fvHFZ0qjcjjxc5Sjyow7HRPtmrBVLuxYDOf9qvvv9kP9mbRfEvwv0zU9ZjluPLkcwQltqn5uSR3r4V8DxmfW1wmNrcAH/ar9WPgB4dbwv8AB7QLRhiUWiSPnrluTX1mT4aNRuVTVHwGd4iUWlB2Oj0Hwvp/heyFvp9pb2cQGAsSbavGPIp1FfTpJKyPmW23dgKKKKYgooooAKKKKACiiigAooooAKKKKAE25opCCTRQIdRRRQMKKKKACiiigAooooAKKKKACiiigAooooA8k/bH+H7+Nvg/cTwRtLdaQ32qNU6lQMMPyr4J1axMF1+/3ski5GT05xX6mTwLcwNGwDJICrAjgg9Qa+B/2rvg3L8LfH8kSbhp14XntX6jZkfL9QTivms7w2vtVse9k2JUW6cjxiK0/su8UhSrJ19a9G8PaqdQ0hG3n5Fwua81ud9x
OwMhxzznk4rT8HeIBYMYp5nBB+UE/wBK+TqJy90+8wVe2h1OuTJd+ZA/zPIpHzE45r52+N/wZPiQf6obwSUbHSvc9UvmOpb1mAhAxk9qpeILQ6hArAs+3PTvmueneL93Q9qnWkndM+EPFPw9n8Laq0V0o2KxywXnA71jaf4OsdR1E+YEPy8buv4GvtPxh8MbPXXdXt0czwmNiR90V454r/ZhvdMvvO03dJF/dJ6fQ9q+owWLSX7xn3+TZ3hZx9nWlyvv0PNbT4O2dzaQS2jNJPLu3q+R5ePTPan658ItQE8csbl1Y4A5HHuK9S+Hvh3UPC8O+4gfMEjEq6byQVxjJ7d69w+GHgvwR4ltbLXPE2qTQ+XbyINIihKosy9GJ6kGveXK4Jwat6noYvNqND3muZdLa/gj5l0n9nS5Ph26v5b3yEiAlYF8ELXJ654Ws4dbH7+WVWUAndwSO+K94+JusRXdtqltp9jcxyT38cVqAmEittuDz3yea4XQv2e9T1zUGN5vjgB+Qjgn8K56lSEI3bLpYilKn7bEvlR5FN4etNVupo47MzOrAB2JOM17X+z18IlsLprr7BHLkKFkI7n612ngT9n210HcrbJUYAkH73Fek+GNBj0p4Y0XagXBXHAFfOY3EOceSNj47OMfRqt06Wx0XgfTU0mxBMKA4+Y+tdrpMCoRMqbe7N2FcXqd8NHgKo2flyMVuW3ihdO8LSuXO/Zn2rxOWXNzvY+clyrVI88+Mupf234xitfNjljJG5fc1X8WgWfhzyI3Ksq8A021hi1TWZ798kkgxsR0A71B4juf7QuTCqmZ5GAJbvmuyk9NGebjqtot7G9+zR8PpPFXxB0uzhJme8vIo37j73P5DJ/Cv1atbVbO2SKMbUiQIo9ABgCvif8A4JwfBh5/GkmuSQhbPR1IQkcNM44x9Bn86+3cc19xlMJRoXl1PzHNK3tK1uwtFFFeqeaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFJ1//XRQAtFAORRQAUUUU
AFFFFABRRRQAUUUUAFFFFABRRRQAgGK+bv+CiWqWek+G/Dv20bYrq4mhaXtFhFYEn8K+ks186f8FG9Fi1f4XaQJk8yP7eY2B9GjYVw5h/u8rnThP4qufCesRy6Jq9zE0xz5m5e42GqWoakxuvNEZ5bgg81V1ln0uSPSr242vGWFjPI/+uQf8sye5H61Vl1L7RF5TMmYh82G5B9MetfnGLUrOUNj7nCV3GXIz0LSL6PU7VWyGwAcMOlblvbIbdQQvTJArzLwTr3kXUkLleoKhu+K9D0mRHtdkmAJOVOaxo83KpHuUK7loSSWiusmMevAzkVX+wGKH5k+Urge5rUt4QxR0OP6rVsBGfaxUjHTHQ10Rry2PUprmVjkp/C8Ukm/ZjzCd5PQUxvBscUkeyQFFGWU9DXWgWylo49hI4O7pmp38MQXjpk7Nw7d666dSSWh1wVSC0PPLrwYDfyb8MrjKAcgGtXTtEdYwqLG4A5J612Fz4bt7O0GWHmZxwefyrOMP2KTYoIyOpHWpliJPRjcqlTST0MGDT3glxsLHdgkcVZhiW1wCmHzzkcfnWnEHhPm7Bt9CtZus3n2S4ZmDMgHPt+FcMm5Svc5a3uyMzxKvnXaMrFdv3ueKxtd8UyXscGnxnCBvnx3qp431/Zp/mq5Udxn7341keG7lbrSzNN8245yOtaQm5S5JbHDUra8psya5FBppjVlXghfpW98FPh1e/FrxXY6dp6eZdXMgjBY8JjqxPp715jrviJVuhHDyQW3huAB3Nev/sE/tZaB8PfjVH9rjb/hH7W1kiudUIzGkjMACP8AZGeTmvaynC06tVJI+VzrFuEHyn6S/CL4ZWfwk8CWei2YBEC5lk7yyHlmP1P5V1NU9I1q18Q6XBe2VxFdWtygkiliYMsikZBBq2DmvueVR07Hwbd3di0UUUwCiiigAooooAKKKKACiiigAooooAKKKKAEoo3fWigBRwKKKKACiiigAooooAKKKKACiiigAooooAKKKKAEr5w/4KMeJ4
LX4c6XYI6vfNfpOYwRlUCsNx9BXt/xP+I+n/CjwLqGv6tKILLTojI5J5Y9lHua/J+y/aqn/aM+Mvj3UdRu2naNrd44eQltFuYKorzsyqctCSR1YLk9vHnL/wAQ/Ca+OvD8kMiruiUPDIp5icdCK8O0n4iSeFPELaP4ggFnfICY5gPlugDjcD2P519DC8WSw2o2VYZ4HevOfi98LLXx3pJt5YUMyqXgmjHzxsRjg18Bz6tS2P0D2cGuf/hynZa1FK6NC67lG5TnJxXoXh/WftdvCpcbiOX3cCvlGx8Xaz8J9Rj0jXoivz7UuO0q9v8AOa9i+HnxChv4YlSXbHuwSR0p0+RpqDHQrOlUs9j6A8NXQDj5/l/h3elX5ISnPybmOOvSuO8I6vCYIJFczBsoh7MRXXWRW+jQSNwD69ayVFxlqfSYef2ia30ZPtHljBDncT6V0x0N7W1A8oYdcgk5xVayeKGZANh4wxPatw6vHDZoGLsw6knrXpU4aaHfOo3ZI5XW7AwL82Q/Zh1NZEk8pPz+W0WMAd63vFEialqaSq7iCEZxnGa5y6uco8iH75xyOlRVpp6Jm8ZRUNRlxqXkHeQoC/dzXH+O9bEbjYGAkbHFa+qzrbQ4808DOAeteW/ELxwkTt5zMGTOAp6VxRoRcWrnmYqp1M3xfr0F1qP2X5iEbbjGMVFrnjiy8LaBIHnji8kbic9BXl/xA+Kmn+HLF7ua6bcTjryx7Yrj/BvgvWv2o/Eka3Mlxp/h+HhiuVe6HoKIw5dGz5+bTleTNSLXtW/aE8Wmw0O4lg0dg6X15ggY7oh45PrVr9oXxxa/A74OX+l2P+jRyNBbCTJy3zjOfrjn1r2G08LWPwy8ODTtNijtre3BCgD73uff3r5C/wCChvjO5h+G8UW3zIpb9RIT6iunC4lSxChDQ8zMaf7mcpLSx+gf/BJT/gqU+iatZeD/ABJd79EnCokkn/LqxGAVP932r9a9O1SHVrKK6t5Emt50DxyI25WU9wa/kk+CXxmn8M3
0EweUbsFEU9GXp+FfsB/wS4/4KrR+H9OtdB8RXU9zo05UIZDuax4wSuf4f9n9a/S6NSFeG/vL8f8Agn5dTxShJxlsfrJRWb4W8Xad410G31PS7qK9srpN8UsTblcVog5qdj0U09ULRRRQMKKKKACiiigAooooAKKKKACiiigBuc+lFN6UUC0JKKAciigYUUUUAFFFFABRRRQAUUUUAFFFJnNAC01pNi5PQck02a6W3haSQhEUEkk4AHua+I/+Ci//AAUs0n4Y+H73w34Yvo57xomF7dRnKxDGNiH196luyuF7K55D/wAFo/25bK9tG8EaLqCG105i98yNxNL/AAqCOoFfBv8AwT5+IKa94u8XmadpWmt4WHqNsjAYrwv9oz49y+Ptcubk3o3ySgAMeSTXR/8ABPHUDZfE/WsygefYJgA4GQ5P9a8XESlO99iMLXU8TCMT7/8A+Etg0SGD7QfkuHEKFRwGNaaweazZLoAcriub8PRrexxPMyyBdpWMgEKfWuutr+OSLptaPoK+Mno3ofp9D3qaPP8A4xfC2D4l6Dc209mu6H5o2H3lPbB7V8/x6frXwY1I2ty8t/phfdHL3T2brmvsOdo57dlw2WHNcLfeH4LnXfLuYFkiJwVZfl/GpoWUr/oc9Zpq1jl/hR8a7XUNOgBmRuGZWzlQf6V7b4U8UrfIgJzwGBHOc14V49/Y6jvLmW+8JXx0e+KkeUSTBL9RXIv47+IfwH1OG11vRb2/t2wi3VihlXjvjrXX7Wi5cuz/AAO/L8Q6cZKX/DH2bDqa87G2rjJJqe88QtcwqI0YuOwr5b039uLQbVov7QN1ZlFyyTwshx+VbUX7fHgMwqy6pHl1IwucjHvilGTu0tUejTxkuqdj3S/1SQxn5sbjtILVnX2rfZoiQwVV+dt3YV4VrH7ePgZrZGS/luCy7gkcZYn9K43U/wBr7WviQkkHhPwprmoN1aRoCiE/UirnGKjd7lfXbR1/E9o8c/EuDThITJhtpYA8YFfNPxm+O0Wo
6sNP0qKfVdRvBsEcS7sMfcdK2dN/Z2+JfxmnkufEmox+GbOTA+zWzZlK/XtXq/wx/Zv8N/CyNf7OtQ11tCyTy/M7e5Nc8Wkr7ts8jEYpyl7uv5HiPhP9mK91i4h1vxaWbYglisFP7uP0yO+K96+EulR6OoWONLX+6o4z+FbHiLT0u5ljMmOBjjv2qXSdPbSWiPy7M9QOayqe9O/QVCnfcwviUjrZzHG5pc4KjP6V+f3/AAUb1B7fwvp+JJMx3ZilOcMxxnp/Wv0F+IEe7SZLnG98llUnGAK+B/23PAGtfEHRbkaRpkmpzafIbuWOFC7pGBjcQK7sBCPtlZGWaythKl+x8p+GPEr2qbGZY8IV8zOCoPpXsXwI+L8nhPXoV+074BsK7nIwD1xXz5d+ZaP9jkhMUsZyyuCCOcHPeui8HXiJbb2myIUJUAcivr1ZH4zWjzo/az/gm5/wU8u/hDrMGm6lI914Yu5FD25feYATjzE9D7V+wfg/xlp3jvw9barpdzFeWN4geKWNgQwP9R3r+UH4T/FK4to45LeVUWBkJKjHQ5xX6u/8Ejf+CjZ8OeKLTwvrd4Bo+qOISrH5bWTOAw9FPevXhWjX02f5l4Ss6b5HsfrvmiooLhZYQyncrAMG7EVIDkVB7V7i0UUUAFFFFABRRRQAUUUUAFFFFADDEHOc0U4DFFArAOlLSKcrS0DCiiigAoopC2BQAtFRTXSwRlmKqF6ljgD8a8+8e/tU+B/hz5i6hrtqZowSYoWDtTUW9hpN7Hou6k38V8afGD/grp4c8Hho9GsvtDZ2+ZO+P0r5V+OP/BX7xH4rEkFpez243bPLt/kBP4UpcsfjkTKUIq8pI/VHxb8YPDngaLdqmrWVrjOVaUbh+FeH/Fn/AIKb+CPh/DItn52qSgEhvuICO2TX5IeN/wBsjUdbvygu5JJ5id5eQvtB715L48/aGurwzxzzu21Dul3cMT6ZzUyrRi9FdHL/AGhSir2ufb37W3/BXnW/Hlxcadpd0ttZncojt
2KqPYnvX53/AB3+Plzrtlc3E9yxluVYFW5B/wDrf5zXl2sfEW4lvHXz5BmYv1+97Vz/AMQPFh1JxHtHkopA2nnmuOpU59TmeIqVdtjlvE2uzX2rxJuU78OCeuRX0t/wT88KxWmoz+JW1SF5LiUWcdiGzMFHJkI7LXy3ZxNrOqoYWkaaWQRoByBmvp/9m3Rn8G6+I42HCAM4GSzFuTXnYmooUnfc9DKKc3iYvoffXgeRLWKQHBLspTviuz0nbcSb2BYN0wK4L4eX5/sm3wp8xlG7I5GK7qykR4/LD4cj5lU8rXzFRNu5+rYfSNi9ewYiDZYZXNYGPtF6+1u6lt3tW/fWsjWSfvR06+tclqUsljq5+QtDnBwaxdoIyxFKJ2+iPs2FlwOg5rrbfS7a+t/3iq7Hr8vT8etcPoWofbJdoORjgdxXXaHK8ducEn8KFSUndmtKkpRuM1T4LeF/FabL7Q7K5fODvhXkVkR/sd+AIJSy+GNNxKCMiMc16JayRgKwVsu3yjHNWLmdo+OQB93I6VFSnBPQtxvoecwfsteC9AUmLw5p8TY4YQjitS18J6f4OsfJtbOGON+0a/4V0d5qjX6HliIhjPofSue1a5ZlKOdpK4yK5uVWutCeVc9mYeshZzIUX5emOmB+Fc9qzxaZpUrhTnGeDya1zdfZw0UzjGcD1/OuX8UambKBpcJ5Z+XHWt6cLK46sVF6GZYXovbwbUO0jeS7du1bLzPd2mXUL5bYGKxPDKm/m83GEznJrZ1qdri3baW2ocNu71Kf2UKKfMrbHH/Eq7dNBmU4BAYuQOdtfIHjr4n6z8P/AB7a6noF+bG5KsgdRnzF/ukHjFfYXiXbexurSEgRlWHsa+LP2hY47XxnGdhjSOUnpjg1rhako1U76mWPgp0ZxfU9GiT4V/tw6VPoHizQdH8JePzan7JqtqogW6l285HAGfqa/ObW9Jn8E+MNa0i4kRl0y8lsd+fvbGwf8c19K/EXRoUsI9YtpPntSSrxOQUJFfK/xLWfSv
iNqSXLSRySYmBY5D7u/wBe+a+vp1/atI/KMfh3Qm10Ot8BeLpLBxH5gEPmKev3hnFe3fB/42t4X8UW8kE3k+S4cvnrg5Ar5WsNci+0LtZh5QAIB+9zmuutvFhs7a3nXefKbLgHmumLanc8SWsrn9En/BNr/grLY+I/DGnaF4yvTLESIba/PLRYOMSH096/RLSdXt9asIrmznjuLedBJHJG25XU9wa/k7/Z/wD2gW0HUIE81gLgbQScBWzngV+ln/BPv/grVqfwmeDSNRaW/wBLMgRreSQsFwcErn7tezCpGrvpL8z0MNX5Y+8ftGSVpQc1xPwS+OuhfHnwZDrGh3PmxvxJExHmQt3VhXZBsflUyTjoz0YzT2HjJHX9KdmozITTi2RSLuOopiNgU+gAooooAKKKKAE6UUA5FFAAn3aWq15qsGm2/mTyxQxjktI4UD8TxXnHjz9sHwF4Ajb7Tr1tNMMjyrc+Ycj36frTSb2BXsenFuKC+BXx78TP+Csug+HTJHpOn+ayvsD3EmP0FeCfFP8A4LBa+2myeVeWmnxsG2tAvOD3qJVKcPjlYJuMVeUl/XofpF4v+I2i+BrVptV1O0sEUE4lkAY/Qda+c/jH/wAFSPCPgmK6i0WJ9SuoE4kkOyMH6V+WXxb/AG5Nb8b63cyXmqSSl1zG3mEuwPoK+f8AxX+0T/ak95JNcz9SDl/m4rH63TT01RzPG0otrc+6P2nf+CqOuePxNG2rNBb7d6Q27mNVH4V8cfEb9t+81Se42XUm91Y+cD8zfjXz58TPizCJHVHlCMAoJcHDV583jKN7lwWjJRPmbJwSe2Kwq1nP4HY4XjKs3zJ29D2fV/2hdT8QXBWS4uJDnGCO/apLXxnd6XbSyzE+ddkvGFOeB/WvI/Deu4LXsz+RAqERDGMkdDWtoXjBbqzCzJmdXPkyg5Jz71EEtJMwTc93qekXGt+WpIT94Rh2FeZ/Ebx1E2pBd37wHG7d1PoPWrPirxO1rosu6YfO4HPUe1eUeJJv7Tn
MhnVhv3Jg8g+1W6isyOXl0udFpPiLF2FuQcIS2WHXFYWua79p1yc5kwozgd6i+0SWummUsrkHaCRnGaxLu8kkuRnaHLfM3r+FYtcw43b0PYP2VvA76zqF3rFxFKbWzKqEIzlsZyK+gPg9avovi943bKEkpnjBJzXmn7HPiGG98HavpkuRLaOsyFV6jpk17D4G0TzbtH43Tybskcla8rEu07H2OSQjZPufWfwjt5Ht4vOciTHJQ8V6JZ6eJLwncc9SW6tXk3wt1H7Pp0VuVIzyrfjivW/Dl+GgCozeeG5bHFeHUknI+8w8y/q0ZNgXxmRR0XtXJaxNIV8yTgZwStdimLmIndz90kdzXOeLLR4IxHtwo5J7GspR6nTODnTM7w9qTWd15oDMOikHmvS/DetPd2yt0AXArzLwhJsvdsxXDHAweldxp0Ui3K+VJ8vTAo57xFh3aNjvdL1RHlUOXGBjOcEVo+erRtvkZiOnNcI91cWDISSS3360k1eSFABu5Gcmua7lJJnTbXU1lghsoJWyf3x3Nz3rG1KP93tV94HJzUlxfNLjOOeuD0rL1HUpFDBAv3ucDrVOwuX39DC167W1UuCpIfHzetcXe3EmtXm1iAGfDDtXQ+KnjtGeSVyWK7gvqax/D2mpcSvNKfmc9AeDVupFtQRzV7SkkjT0ez8u0RFCDY3TGKn1gPFbEAqgxhsfxVqWdnHCUHzjI4ZjxWV4htWgG4tvz6GhWVSx1U42fvHDeOJxE74cqdvAA6V8nftN6JHP4it51lBDnkH+tfV/i8pHHOQd5YYU5zivnj47aL9o0dbhUBmi5BPf61EP4lzz6usWeOXmjW9vpN9BOyXMa27kKp43bMA5+teF/t0fCs+DdX8JauB5aajpgik2jguvXP4EV9Ca3bjUBYxx7UeZ0hAYY80luwr239rr9j8fGr/gmx438YRWYTWPhxcW91bSesCpiYH8zXv4HnlP3eh8Jm1GFRSb3SPySivAl9heBnCrjBNbUOpS2PnjhoyoIYc4
zWRfRm0MMg2N5h6gfMadf6m7WeIEbbIMMR046170bWufH2Skdh4G1yX7THubbJGUfHTkV6xo3xQvNB1xbn7QyrMxdNv8POT3r548NavJZ6gN8gyyj8cV3Og+JhNpbK/76dXyofrg9qSbtZkvXXofo3+xj/wUl8S/BrUYbi01q4tWHykE5WT1DL6V+k/wO/4LXWetQ248SWdtcIQBLcWp2sn1FfzteG/H82n2+8ld2AoXvgnGcV7X8MvjXdQukkMm8wBBIzjlvqK9P67NQSsn6nV7Z+zXLuf0z/C79t74dfFaGL7B4gtoZpeBDcnymB79a9WtNQivrYSxSJJGwyHRtyn8RX8yGjftQar4OuftVncSYCiT7/Qnr1zX0X+zv/wVs8b/AA/kjMOrXX2eDqjuHQ/7O0mtIVqE9G+V/ejWjiVJ2lofvUTTt3y8V8Jfssf8FnPDvxLggtvFaR2s8vH2mAcA/wC0p6fma+wvAfxl8MfEm1Euia1p+oA4yscw3L9V6/pVulJarVeR0RqxcrI6pXLU8NkVF5pA6U8SY/KszdMfRR2ooGIn3aKaZdhxRQK6PxD/AGjP+CmmueOdbv4rnUp9iTyRBDIVUAMR90HHavnPxV+1dfXZwl9KquCxOc5z3r54+IvjmT/hLtSk8xQy3k2PbDt1rktT8fQzzujncVI5XIwD2ry6mKq3vI86Veo7xvoe6a5+0Tfzyspu5GlOUU4znFclrHxlumtsyyvPLMcBiOgryW58WqkgMecFmJZh0rH1HxZKl5ExYhAT07Vn7VSRzz2vY9I1Dx8Zb55N7SSQqNwU/dA9K4rxP4wN1bPMu9PMYnB6gk4rnI/FUSRSyAiN51we9c3qnik3CNCJCyRjByOc5zmo5ddDB3bLeuajNLLIqOwj3gHkctVrRnlvLmCNAUAHzN2Yj1NcdHLJJgRucyHADc/hW9Jqf9g6Pt+dZ5AoGR0ammmyoxsjpZ9bTVZ/s/IeEk7CfkxWj4f1R729T5fLit4vTHzfSvL7rV5pr
geXKRh9zEDmu7kvf7M8MIu8tJMhbfnqW/wrX7VgW6sM8a+LGM0sYzOuSG+p71ylld/brv58kIcgKelNu9WDSNnc7jP3e9Z1rei0ceWcNtx/vUk1cp6aHQ67qbjTCOib1Py+nrWBe6gPs+Q/7wnPXpU97qe/S5AW+ZCAfpWdPFHLET825l4welObjciKa3Pdf2JvERk8fX8OTtu7F0CkcE7q+0NE0U6UtpKMbljxknpXwD+yL4mXQvjhowaQCGWVrWUt0CEY/nX6RtoEkVnACrM398dMV5mOjezR9zw7OMqfK97ncfD68Z/KUIVHGRnOATmvX/Dsnkw5TGYlBI9c1434DI0qWXcSXYq2Scj61674R1aO6iXaW2hVU5HJNfPTjGEtD7CnpKyH/DA68NV1iPVwn2TzWe1denlnoPrV3xNYyxxszOWiDZIPStuylPKKMluWHQe1M1WPzoFRlGAeQ3Q/jWEL295np894cxxWlWaS6mHAUqRuIruNJY78kgHOMrXKajZi2mVo+GJwQvGK3dAu2dG8yML83GKrlutNjnhzLXodXEHnbbINxHU4p8loxjOOMnn2pljc4hHXcy4JJq5jdDlj3w1Y+zaeprfXQzZbSUldmduMkAVm6xM8UR+8gAxwvWuia7isrYgvgOMLzk1zeu6rDaqcsHGMjnrSv0SOinNnJa3bHUZvNlB+9jBrW0C1gQiPGW5AqleXf9pRnYnKNkcVsaJZCONWmi2S5JGB0zVqyhdGXLzavctXm0Lkocp8nTgH6VjeJ2dY92HVW+6K6C+aJICMHfncR71yeuExagFAMjEYAPIoU01rua1JWp3ZxPiSSNnYb/nyQcd8V5N8RNOF5YXKBd+0YcH1r1HxnH5FwSqbsE5ArgPiBf21np0vzyLIybzhc81FO7kzw8VV5Y854t8KfCV543+Mui2pX9xp0puZuOFCHKj2zX6m/Cn4Ax+NP+Ce3ijwxd74o/Fek6h5q4+aVmVtv16CvjP4AfC5tF08M8O7U9UkUEqORu
YBR+or9ZdM8JQeEPBOk2BRVWCxS3ZQOOY8N+tfY5PT0cmfGV5fbfU/kD8VaRLo88lltfzLG4kiJPBBRip/lWMYpvsU287BGxK/3eetetftW6Qng39pLx/pEW4RWniLUI1Uc4HnsRXmc9qzHyHkbDDCA9DXcvU+Uq6VGY1pL5DKMqhJxkH7tdN4N1IRXIWZstKQquB0IriLwSafcfMV+9jnua3LK6kg8m5RujAsB0yaadnqzLZ6nTtr+2/wfL3RsAOcHAOeldT4U8bnRr8Ord8tzw1eb+IIzY6gkqOHM0IlLDnr2zUkE80luX848AEgcdaG02Xoe8af48iguYy2ZYXXEgXnk9qoXPiq+8Oa5Mscsq2zjzE9h615rpGrm1ucfasdG4PUirN54hmmt23Tb5M/ICc1N9bkcmt7n0D8Of2gri3IxJ8yr8qgkc/Svoj4G/tq6z4OaC4gvLlNsgUtGxWRDjPBzX54aLr0ttcxPMzZZs5zgqK63wz8SZbaBkS4bCvwQ2G24x0rejXqQfNF6hZwd0fud+zP/wAFq9X0I29rq12mqW+3/V3R+ZeccP1r7Z+Cv/BTf4ffFGCFLueTSLuQ7WEnzRZ/3h/hX8xuk/FmWAQQ+bzEoOWPzcnNeo+E/wBpjVtHggaLUHRFwmATtx+ddtPGcztVV/wNqeKkumh/VH4e8X6f4qsVudNvba+gcBlaKQNx+FaXmcZr+dX4A/8ABS3xX4Aki+x6rcRuhDAeayhj9M19xfs7/wDBc68laC18SxW1+v3HMn7ubPsw4Nbx9nU/hy+/T/gHoxrwelz9SDz6UV8x6J/wVa+Guo6VBPLLeQSSLlo9obYfTOaKv6tU7fii/aRP5ividqO3xhrSiT5o7uZclsbvnbrXEvr7I7F2wuzB9yK2/jB5sfi3W5VkV/8AiYT59sSMK4qa7P2rLkgYLc85JrwpWeh5cYu2hranr5ntcKuxchue+KzbbUnZW2Iu7JZRk8+1QXEhWBsSA71yfb8KnmuGs0RvlbagOU5
zmslZLQz02ZHPexzxuJNwO3OFNYRnSRndN+PMy2TWneyskAkAbfKcDHUfhWReNJIGUAK2cEYq1dbBqangmBL3xKjOcoikjceMip/Hd1cjUCSmIMKoY+lYul6vNbwoB8vU5x2NbviK4m8S2tvcRb/ssYG8n29qNb6iUbGTpkAuJokQ8s35V0XiTU/K+VnCNGiqX6GsfS5v3xliyYw2GC8GptfvJNWuVJT5NoXpnOO9NthYwY73ZcsVGAVPU+tV7K9KSszc7Tgd+PWjULRoJlKMMAY571PptsdhZwVXufahNNXFK9rDVuAkMpkAcdTg1YN39pX92hHyZBziqt+GYkZL8bgp7L61HpV7tXD4U9BkVOzLafLc9P8A2R9JttZ/aA8M2dyywpd3qxtI5yq5TGccfxe9fqL4H1G38UaebQyYuLRvs9yCONykjI+v9a/Ifw9q82mavb3FqWWa2ZZFeM8qwOetfr3b2qab4K8M/ELTd7aV4m0W2lu0jXftlAAL/XOc152P5uXm6HsZPXqUqq7fkdO2ltAGAC/KqgkcV1XgXUmWbIU5jCq+ewrl/CGpQeJYmlSTzd6g57YBx0q7aEaTqiKJMLIyt1zurwKnKpXkfomHkpLQ9k065Ito2i5OMHjOanln+3QeYibTnle1cv4Rvo/MSRJThhtCt0+tdTIu2INFg5IOTx1rJ25OVHrUkmuVGXcQec/zpgBs5A61csYvMGzhSgwc96k1mcxxn5V3dHwKjt3OUVWO/wBCOp9KhKUo2udMYO1malqrMg2NkKOaIZXUMpO75snNM+zMkQYHapHOO1SyWX7k4OAT19aq0uXUrkVyteb5wxUfjmqNzpMk8I3RgEHPWtuKBIuCW/AVHcsmSMfKw4zRCyVzVeW5haXpnmXRJfbk1u29qJOh4zioreEWzpnlOtXYP3Tbxk5ORipdnGxy1F9pbmXq21Ys55PYda4nWriYTlRgEkjIPpXTeLb1ouY32noNvY1xuoztKWk7Ank0OkmkznxEn8jA8UP9
it5GkX94D8w9PxrhfB/g24+JPjeK+kVo9L0mViBu3C8Y9eO+Kt+NvFUni3xzbeG9Klb7Q22eeRBlAgbJBPY16p4M0K30UC2t4BbIhyVA+8e5rfD4dOXM9jwXD61P2UXot7fkdX8Efh5Jrfxn8M2MUR/0u/jdwOmyMhic/QCv0B1S1/tJXHmA7GJ2j0Az1r5z/Ym8Drf+PJtckTdFpEJijJ/vyDB/8dr6E1zUZ7O/UQRKyu5Vtw6qRivtspoclC76nh5nZVuSPQ/kw/bhmL/tcfEeVOkviW/IPr+/avHjeyM7NG+3yiNvHTNewftzOLL9q74kR4+QeJb4D/v+1eS34R7UmLoVO5h6mla2x8hiL+0Zj60/mR/vHA+YAA9ie+aek/8AoO1CuFZc7aZqtwLvTOFwxUDC9ciqmjXEqq+3lchTxSTW6Oa+l7HUXTpLo6yoXbyMbvTNU4tRUwyMsp5CjHrUWn3bzW09vt+Z1+UKPlB9apWF3LbyNEYw2TgYXrilzLfqEVK+hum/MgTdhTC3AXnNPttWkmmPm/KOScelZ1lqDQ3SqFOWPp0q3bXflozGM+YSRyMhQfWpU+rLSl2NC4f7ZE0kcj/Ie3YVa0/VERflZvMY43YpPC99FPeCKXYrXACk9lqlqkX9mXjqkg+WQlTjt60Oy3ItK2x1smufbriJQucKoZwpB6ZrU0vXXiT95LJsUgKq9BivPU1ya2XcJNuWHBz6Y9auaf4mklhA3/Nv3YUdacHbW4rS6I9W03xzcHVohHKN7Ank4AxXZeF/indSkQ4zvO4jdgqfavDLXxD5VznLdSQ2Oma6DTL83k8UkbtvyQSp61rJ6otRV7s+ndM+PckNjGpu2BGeN5OOaK8ETX0SNRhvujPHtRWntmdWhD8XYY/+Ez1hQSv/ABMZw+enMjGuNvIoXDSqyts+Ug9T+FdL8dLpLT4j65EN5X7fMBjn+Nq4ZJ0juP8AloRjOTXE2zL3dizdWe26mJGWMfAWqNxOCFXO4KBuOcdKJLgXr
5BaMnjJ6VWu7fZhRIfRjng0RstG9SHbZlhtT3RllYEE9+orLvmWK43gsckE/jVyWMiJv3SoufX+tZpufPZl+ZADjcRkcVUrNaEaXsiRds8JBJXB/T0rV8LXWbaS1NwEjuBgZOc1jApFbc9cZDY61LYxbXBb5cfMD7+lRdou6vY2o5YrC7bO4qARnsxHeq9zdqt6X3fwduhqbUpGu7CKKOIEOCzFRyKwnm8omPB+ZsDPUD1p6vYfu2ZLc3Ie4xuwScbWNWJ71YLT5mO9RtKt/CaqadALmZ8jcA+QzDJpl5FDFI7HkupyB6+tWko6ENJa9CMXHnXik/cZfWpbdFmjB29D0Pas6KDMcbnHHJPpT7eZYnc+YzZG4noB7U2uoLl3sb2mXTW+4oCiD5Tg9TX7A/8ABMrWv+Ex/YK8P2125uDFcXdp8x3eWqv8qj8D+lfjZp03mbV3nyyck/7Vfq3/AMERNZXxL+zL4k0klvM0TWhOq5+6kqDH6g/lXHi7ui7I9vJLOuo2Oz0HwvqPwY8fSWonkn8PXbokTSSZZWJ7+wPFeg6vB+/jkU4g4+YHcePTFdX4/wDhzb+JtImt50GZgOT1T6H615n4cg1vwDf/ANi684uLB8izvfurGMZCsfX8a+b5JSVnax9om8PJK2h6F4V1LzUTl8EfKD3r0rTZfOto+ONqgg9q8i8PXUmg3Ecc5UhSDEc8EHpXrXhi/S707eeH4BqIJRhZrU97C1FyeZZu4C7AcBDz7igtygXbuJyCeM1antzOrSKfmIwOaxLiN2vFAYfJyD6VnGTi7s9CLbWpvbfKsxkIeMNk1l3Oq/Zo9pBY57DpTI2a4kVpHPy5wP71RXR3FmyFz0XHf0pVJuwotJ3Zft9TaSP65zz0xUTXuWVZD/rGwCRVCJ44nEn+2cgHrmpnZpZTnfGF5yv86xXNuzVSXNoa8TxtFsw2cYXNSXN80Vns3AEnBwKrWsgK85wOckdKg1SZNn3n2dSwq6b97QyqLTU53xKyyXL7c9Ccj+
8K8u+JPjOezgFlpZS41Wd1jEAHSM/xV1HjHxZJbaj9htQlzfXOfLTOdpPc1ofD/wCGq+Hf+JldrHcardf66Qj7n+yvoK3UXza6Hg16zqSdCn8znvgp8F4vhzavJcjzNXvnaSeUDIXJzgc9K9d0fSkR2kALHr0qtaaassucEgrzg9D6V6L8IvAj+PPG2m6eF/d+YslxjjZGPX6130E51bUzSlCGFotrt97Pov8AZm8Bt4Q+EFnJJiO41Ai5lbufQfgK6zWtXhtzE6fvSrhSAM9e1a0NnHFbxRZ/cwqI1TsoFc74mf7Am5IvlibzTt7Yz/hX21OnyxUUfDVpc9Ryl1P5Ov2+l+2/tffEs+SbYHxJfsExgqfPbA/KvFNU1b7BbmJsjA5K9CfWvoH/AIKN+MbPxz+238T9XsIBbW95r90VVOnyttJ/EjP414Xqq2mrM4WNVbA2S+57VweR83i4p1HY5polyH6bh8oBqKyjEczBWIUnaRnqac1l5M370BZQMAdjVRpUt7iNo8s0bgE9sVN3J8pilG9jcs4HsbtOWRXOTnrVa78zTdYcK2Rv3BgegNWLzEixy/PGc4UA9aTXIF8pJYwwXIDeuBU3cdJFe5fYljmV0DHiUvgiiXUVZEWPG0JtP+0fc1Vs5UnJAbcMkhhzmn2tg8CgECRZFyAByDRLXUcLPY3NNIsZorj5XGR34FV/Ft6l5dNyoyuAVHrVzVLaHRNFidHb96u0A9zXKT3YuJmO1tzsBS6XM3GNtC/piG8xul+VFzlh1q/AVW3dkfG3kAdaw4o/L+QK5GcHnpWhaOkbtIc+VIu1cc4q7tlQjfXodNpl5si4CsWXccjrW3oGoGzRNrA4BY7O2a5GyuWj+8z4jG1Bjkj1q/pkpkI6nIxjpx61XMy5NXPRLCbFonI6cZNFYlhFvs4yDJjHFFK7A1vjncH/AIWR4iCZDLezFfxYn+tcC+qNI2xiRzg/LXof7QbeR8VfEIjV1jNy5Yk9c4P9a86SRGUOWPmAcc1nzaj
5Y7kl25jKuoJLA8Z449qZHdiKUZXIY/gar3gi8pSr/OQSw9M1BdRDbAkbv1zuPanYltdS9POz3RJP7wnO08rVSWUl2XYG4yuBxg1G+6GQElmJUj8acZREUwxwcK3fih6OyCKW7QxyZLIrhvlGI/8A9dFtLIF3SZ2qvPufWnRFcSJ5ish+YY7e1RXsYRhhz93gA5ovpoRKNnoaWg+JltLmWJyWbH7sDtWlrHhPdp8VxbkGJzgljyo+tcnpigh3JYbh1zXSeD9UkvrJtPmuI/VS3TrirjqtBLYqWyNomoRoNrrjc2T0rLvZjJdTPMNnJK4NbGpJHo2ozLHIZpIhjf8AwmuVvLf7ZMLhyxDJx2qlbcrRvUnh1AICW5BIXGPWnBvs9zuXGCcEEZH5VGyQx27N827gHvzUVrL5TJI8jeUox7UaNajSXQ1LR5vsrbFTGSBj1Hev0b/4IB+Mni1r4laDNOoe9srW+Rcfe8t2U/zr85LARsxEZH3iR2xmvs//AIIs69HoP7VF5bGQo2oaNNHj1cOrY/U1jXhF03fqeplDaxUWj9a7yyTUNPI2jcBn5q5nxb4AtviJ4dl0q4jzAyFPQo2MZB7EVp2PitLklS2V4HSq/ibW9Rs9Ntf7JaDcbqMzl1/5ZZwa+Uat6H65HBqdKzR8++Hm1T4N+KJdE8RzNdWU1yIbK45fyYx93ca+hfh9duthEWkjMTnCZ6t9B3qt8RvBlh4t0qbzot/8QJAyT2rhfg146l8N622ga7KIZ4SDaSykAXCk4C/71ZyqXfKeV72ErWl8LPbwuV7AAZFZF2kc8p2gjB+Yit6W6hgiUOB5ki/IB3+lZNzo6klhuAc4IzjFZKDWp9HRs1dmfcXjWlmOW3IS2QMnH0qPRbk64kd0sUio4+USDBz64rXXQyy/KOD8p9SKsw6VtTapY+lNp8po4p+8ZE9p5NyVDdD0HSrtpFKzZ4KngH1FPFtLAyjg85GR/WrNtAY5SfmCnPXua53zX5SXCyuWraJY4+EJLcE4
yK82+N3xDOhwJp+mxmfU7k7YwEykXGfm9K6zxZ8QIdFuY9Nsv9K1O8xHHFHzsJ/velY3hv4ajQtQuL+/In1O9l82Vyc4OMcUSdtFuePiakqr9lS36vsc/wDCD4dzWpXVdQ2zatdBVkYn7pHpXpU2nrDb/vEYnGeR1NTaZpKpdhPlUYyMetW9fRUQZOVA7VteMo2NsJgY0kooytOgeGfgbQ3J/wAa+qP2RvhvJoXhmfXLpCs+r7Uj3DlYx0P4187/AAS8Pf8AC0viXb6LGn7r/XXJP/LKNeufqa+6rWxh0/TYoLRNqwIqIOgwOlfTZFhtPavoeJn+IcbUUEsTWSAIm/J5zWH4mukjMqyBVjMEpdjwFGxutb8nmy2/GN20n8q8J/by8XXnhv8AYr+KGtWbsl7p2gXLwvF95WCNyK+mbSXMfIyV9Wfy3/tR3SXfx58amORZUbX70I6dCvnsQR9QK8m1cGxdywcbANoA4yK3PGl9MNTWfa0gkYs7Hryckn1rG1PUrSa1kVRIsoKtkHqB1/OvLu9z5+b/AHjRl3er/wBtN+8PKkDdjbzVFh51y0eW6jbkenvTruCPaZtxXJBII6mp7CaOaFUHLFsLu/xou90YK0SfTZZJbR42Zz5T8E81OsstzIyyHHPC9ajsxFHfoCf3LnawB71YvLFbK4Y7T8xyvp+dTuxxTt5meiNDqexCAcZAUcc+9dV4bu1juozOuQRtXArlpPKuLpiow+AAAe4rTs9UNrozKc+ejYyKqKTdglpsM8aao76mY1kPlI20Ac8VnWk8kEmUZHT6fdqCeNZJWfzJN+7PJ60yS5jCuyD5y38NN6i5XLYsPeM8zRK/LPkjGMVaS7BthkhCvUf3vpWfZeYJcvu35+Y1LbW2yQy/OVY9/wCEetL3YuzNY3tY3dPuhcbVZh8rYORzj61o6bemOdY1JK7z8xXHA7VjWl0iTFTJwoznHStLTWMISQPvGS7D1BrR2UdCU/eOugu444gASAO1FVrbElupyeRRTTN+S
J0v7Qyk/FjXlUhl8/LZ7ZVa87+zCOJjtGQPlGetei/tJRZ+Ket8FGklUn3+VTXm037l/mXOV5A/h/GsTn52kOmsmugN21VcDoefzqWLSxazhf7idTzmoLb97xlFXg5PtV+O5ENwdqqUJx81ZvfUTbauZ625inKF/kyWGe2aq3cKx5zjzMcYNa+smGWYrnJI/iNZL2e6X5MPt+X8aN9UZ80iKBypxlEC9WPekdHnTHXzGwMGrem+HHu4wJh5URG0NjpWwdKtvDX7tB5km0MGY/0qlv5le9a5njQmS2iDgqJBu3f0qH7J9jCxon7zBOfQA5zU1/rYu9N8tiPMj+7jjFZklzJc3cQ3MFjBQ7ewq9kKXNEspAzIysW3E4xnpVW+sSkwVnSQ7cDb0FMQP9sbAbKnnJ61fgt1ydwG7GATxz6UtXqVzNxsU7iHba5yGdlAGPQ1UkgAjHOR3HYU+6dvtBAYYwo9MVJNHEsZySB1Iz29aE7O0gTa6k2k3O2fqAemTx+lfV3/AASZj8z9tnw1EpVY760u4nHdv3ZI/lXyTZW6vdIAm0l8DBr6u/4JWtBD+318OFDFGkupYjzwcxNWdS048qPRyq/1qFn1/A/Wa20WW0uZCNw2sByOuKt2eoyKpLBiFb7pGM85ru77QolvJAyKQHI46CqM/huOW5Zog2MY5NfGzbpy5bn7thrctmZkmseagfavzDGCOBXOeLvgxpXxTs1knHlywOskTocPG4ORg11V1oAVVCckdQau6VppF18qhQoB49TUzVOpDzJr4WnOPKzhvht8S7nw14pt/DfjJoPtE28adcKhC7F7E+pr0+5/cnryWyMjiuc+J/w4t/HeiurhY7xFIguAP3iMe4Ncr4C8a3Ph3V/+Eb1icy3kCbre5c/NKnufWsqU+Vcr3/r8fwPNo82HlyTfu9z1nRoVvjnGfmwSOgrorXwvGhB+UcAgjtXyT+3X+07q37P3w20t/Dt4tprWsXwt0YgboY8ZLAegrrP+CXv7XOu/tIaf4w
0rxXNHdaj4YMUsVwEUF42BPP5GvShgp1YOSZVXH0oVPZSkfQOqaIkFq5ZeEzjtyO1eX/Fv4pxeDIo7a1BbVbhGNvHt3BucZxXSfF/4zxWWpNpeiwnU71hl/K+7GSM8muE8G/Dk2uvf21rMovNRIOwE5WEE5wBXmzdly9e5lWxXtrU6Gr79EdB8EfhR/YrXeu6mgm1fUiHd8/6sDsB2+tdRqUY853Y4AOBnvS2GpubUiPPTDVS1KGSSfJ3cnIBrZckY3sejhsD7OH5kEurC3Y4BLKeMCs7UNfnm3/IPLTAOe2elbFvoUl0Du4yc8DGK9L/Zt+BSfEPxet1cp/xKtNk8y4JHErjovvV0qcq1ZQpLcMViKWGpOpLt+J6p+x18FV+HXhSTW72DGsa3GuNw5ih7AfjXtcSmFtgIYMMj2qJHihVEVCeQuAOFA6YqxfXGPnUYAGRj0r9Ew9FU6Sij8uxNedao5z6lPWZXijCxH96UbC9zxk14N+0kP7R/Y8+K0V3h8+HL19hPT92xAr1vXdbl1G8t4ll8pZFby5cYI5yef0rxL9svW4fCX7JnxlvnOVi8L3JAxjny2FXP4bnO9Ian8onijabojeSmfm5+6PSua1iJWRSv+rYHJHUCuj8XWaSysokI8znrXL38EENjEscoMuCHPUAntXnaJXTPmpq9R6lR7kSRlWcnOOo9KLiBI3Ux5xUBsJG3ORkoN2QeBUsLAvuEgG3HBo22IaS1TNbSJovLIcL855JTv61tXVrG1pns3TJ6/SueW3W5nUBnQnnk8VqXSra2ChpsvnAAPK/QUk9b3IV5K7GWOlpb3/mfP5JGfm/vVR1e6ilu5sN5YVCwwOp9Ktx6sYtMMDv8jnC5+8PesTUNLlth98SI2SfUCnZX3NbK+rJkCRrvf5wRgFV4NQK3lXBEeBuNERzaom5m3Nkg9KYLQSXK7fl2L82aNCUl3L8QPmN8oIcY4PWpLZ22OpUNxhsHtTU0ssiFR0Bbg/wioWsCh3bgIwOo6k1nZND
i2tUyxY2zTLtkYfdyPcVsWdsY9m1we20HqKw7S3cTOwbhFxgntWnpTGKeNW+VQDk55yO1a7qxb33Oog82OIAN0opLO0eS2Q/NyM0VorFfM9C/aTk+zfFXVVTEihkZsjlcoteU6ndefZH5o3Vs9TzxXqP7TRI+L2qcnLLDnB/6Zqa8nlDS3uMJiTPtj8K5m3eyOdq2xLaxR3hTovy5PNT6iLe0ZNkryqACCRjBxnFMsLY258xTzwvPPWqesXZhdcZ6jOe+Dmlo9i0mlYks5xcSruQfNxlq3dF0yN43nIEjIuQp559ak0DSiNMdjsfjcNw6VBPqpsbkLHkKFAIHem4taEpXWga3rfn2S28JQEHqR39Kyb0q9x5ksnzsAhHuKPNaSfaMfMu4Z9arariPEgzuzt69/WqV+gJ2dhCii4Aj+UYJ+YfexUM9tK7MoIVXYYKnG6pL79yCf4wGAOarTyttBDMNh2gfTvUrsiW/eImufssx+YMGPPNTJdMUZVcAMoJOe5qpf2++fBPJPbjFMDNbjdnO1QMdjirXZCSu7luZSZMeZg8dRnOKcx8yNn+Xn+VRyr9qLli27HBBxinrY7RwcZGcUtpalU9VYtaLBG+oojsoyRt59a+kf+Cb9x/ZH7evwxlh6/2sq89wUYV81afJscyKARgDnrxX0N/wTmvm/wCG2fhi25iBrCYH/AWqfQ9HLnavBn75XOmxvcyZI3O5OB05OKpizaJpCijI64NXJbcXF42MriQk+/OanFusDHZ/GMnNfIVre0ufuuHmuRGTHpyTyZ+bgZYirtnaAQmRkO3gADvUSKsd1tGRk7TitnTLFXBi+9tOQTxWTimtDe9lcz9UtB5eccqMjvzXkPxZ+G0Hie4a4kJinjXEcinBWvctZgS2tfKxzjlq8J/am8RS+BfhjrGpWxYyW9s7r67tuB+VcPKnPVHPiEnC0tj85/2qvivP41/aLfTb65Or6foAFtBCThIyOGx711/7E/xHg+H3xwuvDlpdz2dj40K2hnDF
WikXJVW/A/rXjHwq8A3nxP8AGU2b/ZqF3K9wZZBkM5OeeM11/wAQtSufCniXRLmSK1j1PRrmGf7Ra8GYo6kEkgc8enevr40msMovqfkeJxdOeP5It2vb5H6n6H4XsPClo8axqbrIWSQnLPgY5pkYc3ZzlVz0FWfD+pDxFpNtfFCjX1skxGehZQf61cgsFmmI75z1r5WqlCTgj9UwdKnTppQVi/4fi87apAVf51tzaQJsSeWHG3ABqHQNKBul3Y5XAweld3ZaHH9gTOSwGCc96uNlZHdUxKpxu9jB8IeB7vxdrsWn2satPOMdPuD+8favrDwF4HtPAOiQabbBNkahnIP+tcdz71i/BP4ZweD/AA7FcDy5Ly/UM8uOVU/wg+ldzJarZwgjqfWvuMoy+NKHO1qz88zvNJYipyR2QsZWR8LGBnpVHxBfCxgWFSiTyvtTPf2rTaTyIi3dRkYrifFWqPqGqRR5PmblZWPYmvaeiseDBe9qQ+ILS51uD7LAwMkcTINg+782c14L+3Pq9tJ+xd8ZxfFcDwtdIRnG5thH9a9s1S0vfCOqvcLcq1xDFsGMhWB9a+X/APgq7dNo/wCwR8X7mLAmk8PuWI7/ADc/nWU2lEqduRo/mW1poi53rhsYNcRdA3DhIyu1Tk47muo8Uai0t0577wM/WuRllKzPgDhuMcV50Nrny8nHndh0shyqfLjhTg8c0y8hSGAEc8hTg5yRTS2GG7+LByO1WVsV+ybx9wHPXnNaJK9ibpPUr2lwbRAysyjOQTVi7ufOfBI+Y8NnGPxp4hWfYMc5zyOKi8zzLgqR8sXIBpNa6i5k9ia3ZLgJnAywIyeTWs8yrdc7SdmOKxbaUXWqbcYRMEewFSJeCC3PDby2M/jihpX2KSVuxdOlRXMaNwjYJ2g8cVXvNPeKctjbE/Hrmrtsn2Vl3fP8p/WtG42yaYA+Tgrj8ajRO5MrWMG1EqEZ24XcCD3olu4Um4wu4ZHORmrur6T9mkEkZwFJ4NY1wwkGSSCB0C8fz
pct5WBON9S1G7m442begyeo9avQFX8oIFY7iMjuTWEt44ZVzwOfqPStixmktyjIQA38/Wqe5Tsnc7C1DJbIMMflH8VFZ0Rby1+fHA4x/wDXorTmXYr26P/Z`
},

}, //END METHODS

}
</script>

